import React, { Fragment, useEffect, useState, useMemo, useCallback, useRef } from "react";
import { Link } from "react-router-dom";
import { Progress, Table, Button, Card, CardBody, Col, Container, CardHeader, Nav, NavItem, NavLink, Row, Modal, ModalHeader, Form, ModalBody, Label, Input, FormFeedback, Spinner, UncontrolledTooltip, UncontrolledButtonDropdown, UncontrolledDropdown, DropdownItem, DropdownMenu, DropdownToggle, ButtonGroup } from "reactstrap";
import moment from "moment";
import classnames from "classnames";
import BreadCrumb from "../../../Components/Common/BreadCrumb";
import DeleteModal from "../../../Components/Common/DeleteModal";
import { isEmpty, clone } from "lodash";
import { useTable, useGlobalFilter, useAsyncDebounce, useSortBy, useFilters, useExpanded, usePagination, useRowSelect } from "react-table";
import Flatpickr from "react-flatpickr";
import Select from "react-select";
import { api } from "../../../config";
import { useReactToPrint } from "react-to-print";
import CurrencyInput from "react-currency-input-field";
import handleValidDate from "../../../helpers/utils/handleValidDate";
import SimpleBar from "simplebar-react";
import ModalImage from "react-modal-image";
import FeatherIcon from "feather-icons-react";
import CountUp from "react-countup";

import logoHas from "../../../assets/images/LOGO HAS.png";
import logoBtn from "../../../assets/images/btn.png";
import logoCms from "../../../assets/images/LOGO CMS.png";
import logoWAP from "../../../assets/images/LOGO WAP.png";
import logoNSP from "../../../assets/images/LOGO NSP.png";

// Formik
import * as Yup from "yup";
import { useFormik } from "formik";
import { useSelector, useDispatch } from "react-redux";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import { setClientSelect, setCompanySelect, setBranchSelect } from "../../../store/app/action";
import { resetDepartmentState, getDepartment } from "../../../store/department/action";
import { resetPaymentMethodState, getPaymentMethod } from "../../../store/paymentMethod/action";
import { resetVendorState, getVendor } from "../../../store/vendor/action";
import { resetBudgetState, getBudget } from "../../../store/budget/action";
import { resetProductVarianState, getProductVarian } from "../../../store/productVarian/action";
import { resetCivilBudgetState, getCivilBudget } from "../../../store/civilBudget/action";
import { getAccAccount, resetAccAccountState } from "../../../store/accAccount/action";
import { resetCivilContractState, getCivilContract as onGetCivilContracts, addNewCivilContract as onAddNewCivilContract, updateCivilContract as onUpdateCivilContract, deleteCivilContract as onDeleteCivilContract, getCivilContractLoading, resetCivilContractCreateState } from "../../../store/civilContract/action";
import { getCivilOpname, resetCivilOpnameState } from "../../../store/civilOpname/action";
import logoDark from "../../../assets/images/logo-dark.png";
import logoLight from "../../../assets/images/logo-light.png";

import ExportCSVModal from "../../../Components/Common/ExportCSVModal";
import ModalInputFile from "../../../Components/ModalInputFile";
import defaultImg from "../../../assets/images/upload.png";
import PrintDoc from "./PrintDoc";
import ExportDoc from "../../../Components/Common/ExportDoc";

const CivilContract = () => {
  const printRef = useRef(null);
  const [printType, setPrintType] = useState();
  const [logo, setLogo] = useState(defaultImg);
  const [modal, setModal] = useState(false);
  const [modalApprove, setModalApprove] = useState(false);
  const [modalDetail, setModalDetail] = useState(false);
  const [modalAccPayable, setModalAccPayable] = useState(false);
  const [modalAccPayment, setModalAccPayment] = useState(false);
  const [modalProgress, setModalProgress] = useState(false);
  const [modalMedia, setModalMedia] = useState(false);
  const [activeTab, setActiveTab] = useState("1");

  const [productInventoryList, setProductInventoryList] = useState([]);
  const [blockList, setBlockList] = useState([]);
  const [progressUnitList, setProgressUnitList] = useState([]);
  const [jobList, setJobList] = useState([]);
  const [searchBudget, setSearchBudget] = useState({ value: "all", label: "Filter Anggaran" });
  const [civilBudgetDetailList, setCivilBudgetDetailList] = useState([]);
  const [view, setView] = useState("opname");

  const dispatch = useDispatch();

  const { clientSelected, companySelected, branchSelected, userData, userType, userRole, vendors, vendorLoading, clients, clientLoading, civilContracts,
    civilContractAdded, isCivilContractCreated, isCivilContractSuccess, loading, error, companies, companyLoading, branches, branchLoading,
    civilOpnames, civilOpnameLoading, productVarians, civilBudgets, civilBudgetLoading, accAccounts, accAccountLoading, departments, departmentLoading,
    paymentMethods, paymentMethodLoading, budgets, budgetLoading } = useSelector((state) => ({
      clientSelected: state.App.clientSelected,
      companySelected: state.App.companySelected,
      branchSelected: state.App.branchSelected,
      userData: state.App.userData,
      userRole: state.App.userRole,
      userType: state.App.userType,
      civilContractAdded: state.CivilContract.civilContractAdded,
      civilContracts: state.CivilContract.civilContracts,
      isCivilContractCreated: state.CivilContract.isCivilContractCreated,
      isCivilContractSuccess: state.CivilContract.isCivilContractSuccess,
      loading: state.CivilContract.loading,
      companies: state.Company.companies,
      companyLoading: state.Company.loading,
      branches: state.Branch.branches,
      branchLoading: state.Branch.loading,
      productVarians: state.ProductVarian.productVarians,
      productVarianLoading: state.ProductVarian.loading,
      paymentMethods: state.PaymentMethod.paymentMethods,
      paymentMethodLoading: state.PaymentMethod.loading,
      error: state.CivilContract.error,
      clients: state.Client.clients,
      clientLoading: state.Client.loading,
      vendors: state.Vendor.vendors,
      vendorLoading: state.Vendor.loading,
      civilBudgets: state.CivilBudget.civilBudgets,
      civilBudgetLoading: state.CivilBudget.loading,
      budgets: state.Budget.budgets,
      budgetLoading: state.Budget.loading,
      accAccounts: state.AccAccount.accAccounts,
      accAccountLoading: state.AccAccount.loading,
      civilOpnames: state.CivilOpname.civilOpnames,
      civilOpnameLoading: state.CivilOpname.loading,
      departments: state.Department.departments,
      departmentLoading: state.Department.loading,
    }));

  const [civilContractList, setCivilContractList] = useState([]);
  const [civilContractSummaryList, setCivilContractSummaryList] = useState([]);
  const [civilContractSummaryJobList, setCivilContractSummaryJobList] = useState([]);
  const [civilContractSummaryJobSupplierList, setCivilContractSummaryJobSupplierList] = useState([]);
  const [departmentList, setDepartmentList] = useState([]);
  const [civilContract, setCivilContract] = useState([]);
  const [info, setInfo] = useState([]);
  const [unit, setUnit] = useState([]);
  const [isExportCSV, setIsExportCSV] = useState(false);
  const [statusCivilContract, setStatusCivilContract] = useState([]);
  const [filterDate, setFilterDate] = useState();
  const [originalFiles, setOriginalFiles] = useState([]);
  const [paymentMethodList, setPaymentMethodList] = useState([]);
  const [productList, setProductList] = useState([]);
  const [progressTotal, setProgressTotal] = useState(0);
  const [progressPrice, setProgressPrice] = useState(0);
  const [budgetList, setBudgetList] = useState([]);
  const [civilList, setCiviList] = useState([]);
  const [civilBudgetList, setCivilBudgetList] = useState([]);
  const [invDocImg, setInvDocImg] = useState([]);
  const [civilContractDoc, setCivilContractDoc] = useState([]);

  const [isEdit, setIsEdit] = useState(false);
  const [deleteModal, setDeleteModal] = useState(false);
  const [deleteModalMulti, setDeleteModalMulti] = useState(false);

  const [companyList, setCompanyList] = useState([]);
  const [clientList, setClientList] = useState([]);
  const [branchList, setBranchList] = useState([]);
  const [branchIdSelected, setBranchIdSelected] = useState(null);
  const [accountingList, setAccountingList] = useState([]);
  const [departmentSelect, setDepartmentSelect] = useState(null);

  const [vendorList, setVendorList] = useState([]);
  const [loadingPrint, setLoadingPrint] = useState(false);
  const onBeforeGetContentResolve = useRef(null);

  const toggleTab = (tab, type) => {
    let filteredCivilContracts = civilContracts;
    if (type === "budget") {
      let arr = [];
      civilContracts.forEach((element) => {
        if (tab !== "all") {
          if (element.civilBudgetId === tab)
            arr.push(element);
        }
        else arr.push(element);
      });
      filteredCivilContracts = arr;
    } else {
      if (activeTab !== tab) {
        setActiveTab(tab);
        if (type !== "all") {
          filteredCivilContracts = civilContracts.filter((civilContract) => civilContract.cvl_contract_status.name === type);
        }
      }
    }
    setCivilContractList(filteredCivilContracts);
  };

  useEffect(() => {
    if (branchSelected && companySelected) {
      setDepartmentSelect({
        label: userData?.user?.user_department?.name,
        value: userData?.user?.user_department?.id,
      });
      setBranchIdSelected(branchSelected.value);
      handleGetCivilContract(companySelected.value, branchSelected.value);
    }
  }, [branchSelected, companySelected]);

  const handleGetCivilContract = (id, branchId) => {
    dispatch(resetCivilContractState());
    dispatch(onGetCivilContracts({ companyId: id, branchId: branchId }));

    handleGetBudget(id, branchId);
    handleGetCivilBudget(id, branchId);
    handleGetPaymentMethod(id, branchId);
    handleGetVendor(id);
    handleGetProductVariant(id);
    handleGetAccAccount(id);
    handleGetDepartement(id);
  };

  const handleGetPaymentMethod = (id, branchId) => {
    dispatch(resetPaymentMethodState());
    dispatch(getPaymentMethod({ companyId: id, status: 2, type: "Purchase" }));
  };

  const handleGetBudget = (companyId, branchId) => {
    dispatch(resetBudgetState());
    dispatch(getBudget({ companyId: companyId, status: 2, branchId: branchId, simple: true }));
  };

  const handleGetDepartement = (companyId) => {
    dispatch(resetDepartmentState());
    dispatch(getDepartment({ companyId: companyId }));
  };

  const handleGetCivilBudget = (companyId, branchId) => {
    dispatch(resetCivilBudgetState());
    dispatch(getCivilBudget({ companyId: companyId, branchId: branchId }));
  };

  const handleGetVendor = (companyId) => {
    //{ companyId: companyId }
    dispatch(resetVendorState());
    dispatch(getVendor());
  };

  const handleGetProductVariant = (companyId) => {
    dispatch(resetProductVarianState());
    dispatch(getProductVarian({ companyId: companyId, type: "referral" }));
  };

  const handleGetAccAccount = (companyId) => {
    dispatch(resetAccAccountState());
    dispatch(getAccAccount({ companyId: companyId, status: 2 }));
  };

  const handleGetCivilOpname = (block) => {
    dispatch(resetCivilOpnameState());
    dispatch(getCivilOpname({ block: JSON.stringify(block) }));
  };

  useEffect(() => {
    let arr = [];
    let arrJob = [];
    let arrJobSupplier = [];
    let filtered = civilContracts.filter((f) => (f.statusId === 1 || f.statusId === 2));
    if (searchBudget.value !== "all") {
      filtered = filtered.filter((f) => f.civilBudgetId === searchBudget.value);
    }
    for (const data of filtered) {
      if (!arr.length) {
        arr.push({ vendor: data?.cvl_contract_vendor?.name, vendorId: data.vendorId, data: [data] })
      }
      else {
        const findData = arr.find(f => f.vendorId === data.vendorId);
        if (findData) {
          findData.data.push(data);
        }
        else {
          arr.push({ vendor: data?.cvl_contract_vendor?.name, vendorId: data.vendorId, data: [data] })
        }
      }

      for (const bdg of data.budget) {
        if (!arrJob.length) {
          arrJob.push({ name: bdg.label, amount: bdg.amount, vendor: [data?.cvl_contract_vendor?.name], unit: data.unit.length });
        }
        else {
          const findData = arrJob.find(f => f.name === bdg.label);
          if (findData) {
            findData.unit += data.unit.length;
            const findVendor = (findData.vendor || []).find(f => f === data?.cvl_contract_vendor?.name);
            if (!findVendor) findData.vendor.push(data?.cvl_contract_vendor?.name);
          }
          else {
            arrJob.push({ name: bdg.label, amount: bdg.amount, vendor: [data?.cvl_contract_vendor?.name], unit: data.unit.length });
          }
        }
      }

      for (const bdg of data.budget) {
        if (!arrJobSupplier.length) {
          arrJobSupplier.push({ name: bdg.label, amount: bdg.amount, vendor: data?.cvl_contract_vendor?.name, unit: data.unit.length });
        }
        else {
          const findData = arrJobSupplier.find(f => f.name === bdg.label && f.vendor === data?.cvl_contract_vendor?.name);
          if (findData) {
            findData.unit += data.unit.length;
          }
          else {
            arrJobSupplier.push({ name: bdg.label, amount: bdg.amount, vendor: data?.cvl_contract_vendor?.name, unit: data.unit.length });
          }
        }
      }
    }
    setCivilContractSummaryList(arr);
    setCivilContractSummaryJobList(arrJob);
    setCivilContractSummaryJobSupplierList(arrJobSupplier);
  }, [civilContractList, searchBudget]);

  useEffect(() => {
    setCivilContractList(civilContracts);
    if (!isEmpty(civilContracts)) {
      let inf = civilContracts[civilContracts.length - 1];
      setInfo(inf);
      let arrBlock = [];
      for (const b of inf.block) {
        arrBlock.push(b.value);
      }
      handleGetCivilOpname(arrBlock);
    }
  }, [civilContracts]);

  useEffect(() => {
    setCivilContract(civilContractAdded);
  }, [civilContractAdded]);

  useEffect(() => {
    if (!isEmpty(departments)) {
      var departmentData = [];
      var opt = [];
      departments.forEach((item, key) => {
        const name = item.name;
        const id = item.id;
        var obj = { label: name, value: id };
        opt.push(obj);
      });
      var option = { options: opt };
      departmentData.push(option);
      setDepartmentList(departmentData);
    }
  }, [departments]);

  useEffect(() => {
    if (!isEmpty(productVarians)) {
      var productVarianData = [];
      var blockData = [];
      var opt = [];
      var block = [];
      productVarians.forEach((item) => {
        const varian = item.pvar_product;
        const blck = varian.product_block ? varian.product_block.id : "";
        const blck_name = varian.product_block ? varian.product_block.name : "";
        const name = blck_name + "-" + varian.name;
        const id = item.id;
        const barcode = item.barcode;
        const sku = item.sku;
        const brandId = item.brandId;
        const productId = item.productId;
        const branch = varian.branchId ? varian.branchId : "";

        if (item.typeId === 1 && (item?.pvar_product?.statusId === 1 || item?.pvar_product?.statusId === 2)) {
          if (branchIdSelected === branch) {
            opt.push({ label: name, name: name, barcode: barcode, sku: sku, value: productId, brandId: brandId, productId: productId, productVarianId: id });
            const dataBlock = block.find((d) => d.value === blck);
            if (!dataBlock) block.push({ label: blck_name, value: blck });
          }
        }
      });
      var option = { options: opt.sort((a, b) => (a.label ?? "").localeCompare((b.label ?? ""), undefined, { numeric: true, sensitivity: "base" })) };
      productVarianData.push(option);
      setProductList(productVarianData);

      var option_block = { options: block.sort((a, b) => (a.label ?? "").localeCompare((b.label ?? ""), undefined, { numeric: true, sensitivity: "base" })) };
      blockData.push(option_block);
      setBlockList(blockData);

    }
  }, [productVarians, branchIdSelected]);

  useEffect(() => {
    if (!isEmpty(paymentMethods)) {
      var data = [];
      var opt = [];
      paymentMethods.forEach((item, key) => {
        const name = item.name;
        const id = item.id;
        var obj = { label: name, value: id };
        opt.push(obj);
      });
      var option = { options: opt };
      data.push(option);
      setPaymentMethodList(data);
    }
    else {
      setPaymentMethodList([]);
    }
  }, [paymentMethods]);

  useEffect(() => {
    if (!isEmpty(vendors)) {
      var vendorData = [];
      var opt = [];
      vendors.forEach((item) => {
        const name = item.name;
        const id = item.id;
        var obj = { label: name, value: id };
        opt.push(obj);
      });
      var option = { options: opt.sort((a, b) => (a.label ?? "").localeCompare((b.label ?? ""), undefined, { numeric: true, sensitivity: "base" })) };
      vendorData.push(option);
      setVendorList(vendorData);
    }
  }, [vendors]);

  useEffect(() => {
    if (!isEmpty(budgets)) {
      var data = [];
      var opt = [{ label: "NON CASHFLOW", value: "" }];
      budgets.forEach((item, key) => {
        const name = item.type + " - " + item.name + ", " + item?.budget_branch?.branch_code;
        const id = item.id;
        var obj = { label: name, value: id };
        if (item.type === "CASH OUT")
          opt.push(obj);
      });
      var option = { options: opt.sort((a, b) => (a.label ?? "").localeCompare(b.label ?? "", undefined, { numeric: true, sensitivity: "base" })).reverse() };
      data.push(option);
      setBudgetList(data);
    } else {
      setBudgetList([]);
    }
  }, [budgets]);

  useEffect(() => {
    if (!isEmpty(civilContracts)) {
      setCivilContractList(civilContracts.map((el) => ({ ...el, isChecked: false })));
    }
  }, [civilContracts]);

  useEffect(() => {
    let dataDoc = [
      {
        id: "transactionat",
        label: "Tanggal Kontrak",
        isSelected: true,
        data: [],
      },
      {
        id: "supplier",
        label: "Supplier",
        isSelected: true,
        data: [],
      },
      {
        id: "transaction_no",
        label: "No SPK",
        isSelected: true,
        data: [],
      },
      {
        id: "transaction_reff",
        label: "No Invoice",
        isSelected: true,
        data: [],
      },
      {
        id: "total_amount",
        label: "Total",
        isSelected: true,
        data: [],
      },
      {
        id: "payable_amount",
        label: "Total Terhutang",
        isSelected: true,
        data: [],
      },
      {
        id: "paid_amount",
        label: "Total Terbayar",
        isSelected: true,
        data: [],
      },
      {
        id: "pekerjaan",
        label: "Pekerjaan",
        isSelected: true,
        data: [],
      },
      {
        id: "blok",
        label: "Blok",
        isSelected: true,
        data: [],
      },
      {
        id: "unit",
        label: "Unit",
        isSelected: true,
        data: [],
      },
    ];

    if (civilContractList.length > 0) {
      civilContractList.forEach((contract) => {
        if (contract.isChecked) {
          let first = true;
          let doc = dataDoc.find((d) => d.id === "supplier");
          if (doc) doc.data.push(contract?.cvl_contract_vendor?.name);

          let job = "";
          for (const item of contract.budget) {
            job = job + item.label + ", "
          }
          doc = dataDoc.find((d) => d.id === "pekerjaan");
          if (doc) doc.data.push(job);

          let block = "";
          for (const item of contract.block) {
            block = block + item.label + ", "
          }
          doc = dataDoc.find((d) => d.id === "blok");
          if (doc) doc.data.push(block);

          let unit = "";
          for (const item of contract.unit) {
            unit = unit + item.label + ", "
          }
          doc = dataDoc.find((d) => d.id === "unit");
          if (doc) doc.data.push(unit);

          doc = dataDoc.find((d) => d.id === "transaction_no");
          if (doc) doc.data.push(contract.transaction_no);

          doc = dataDoc.find((d) => d.id === "transactionat");
          if (doc) doc.data.push(handleValidDate(contract.transactionat));

          doc = dataDoc.find((d) => d.id === "total_amount");
          if (doc) doc.data.push(parseFloat(contract.amount));

          doc = dataDoc.find((d) => d.id === "payable_amount");
          if (doc) doc.data.push(parseFloat(contract.payable_amount));

          doc = dataDoc.find((d) => d.id === "paid_amount");
          if (doc) doc.data.push(parseFloat(contract.paid_amount || 0));
        }
      });
    }

    setCivilContractDoc(dataDoc);
  }, [civilContractList]);

  useEffect(() => {
    if (!isEmpty(civilBudgets)) {
      var civilBudgetData = [];
      var civilData = [{ value: "all", label: "SEMUA ANGGARAN" }];
      var optCivil = [];
      var opt = [];
      civilBudgets.forEach((it) => {
        if (branchIdSelected === it.branchId) {
          if (it.type === "INFRASTRUKTUR" || it.type === "BANGUNAN" || it.type === "PEKERJAAN TAMBAH" || it.type === "TAMAN") {
            optCivil.push({ label: it?.name, value: it.id });
          }
          it.cvl_detail.forEach((item) => {
            const type = it.type ? it.type : "";
            if (type === "UPAH") {
              const name = item.cvld_account ? item.cvld_account.name : "";
              const id = item.cvld_account ? item.cvld_account.id : "";
              const findOption = opt.find((x) => x.label === item?.cvld_account?.cvl_account_category?.name);
              if (!findOption) {
                opt.push({ label: item?.cvld_account?.cvl_account_category?.name, sort_order: item?.cvld_account?.cvl_account_category?.sort_order, options: [{ label: name, category: item?.cvld_account?.cvl_account_category?.name, civilAccountCategoryId: item?.cvld_account?.cvl_account_category?.id, value: id, civilBudgetId: item.civilBudgetId, civilBudgetDetailId: item.id, civilAccountId: id, amount: item.amount }] });
              } else {
                let obj = { label: name, category: item?.cvld_account?.cvl_account_category?.name, civilAccountCategoryId: item?.cvld_account?.cvl_account_category?.id, value: id, civilBudgetId: item.civilBudgetId, civilBudgetDetailId: item.id, civilAccountId: id, amount: item.amount };
                findOption.options.push(obj);
              }
            }
          });
        }
      });
      var option = { options: opt };
      civilBudgetData.push(option);
      setCivilBudgetList(opt);

      var option_civil = { options: optCivil.sort((a, b) => (a.label ?? "").localeCompare((b.label ?? ""), undefined, { numeric: true, sensitivity: 'base' })) };
      civilData.push(option_civil);
      setCiviList(civilData);

      var civilBudgetDetailData = [];
      var opt_detail = [];
      civilBudgets.forEach((it, idx) => {
        if (branchIdSelected === it.branchId) {
          const title = it.name ? it.name : "";
          const type = it.type ? it.type : "";
          const budgetId = it.id ? it.id : "";
          it.cvl_detail.forEach((item) => {
            if (item.type === "INFRASTRUKTUR" || item.type === "BANGUNAN" || item.type === "PEKERJAAN TAMBAH 1" || item.type === "PEKERJAAN TAMBAH 2" || item.type === "PEKERJAAN TAMBAH 3" || item.type === "PEKERJAAN TAMBAH 4" || item.type === "PEKERJAAN TAMBAH 5" || item.type === "PEKERJAAN TAMBAH 6" || item.type === "PEKERJAAN TAMBAH 7" || item.type === "PEKERJAAN TAMBAH 8" || item.type === "LISTRIK JARINGAN") {
              const name = item.cvld_account ? type + " - " + item.cvld_account.name : "";
              const id = item.cvld_account ? item.cvld_account.id : "";
              opt_detail.push({ label: name, value: id, civilBudgetDetailId: item.id, civilBudgetId: budgetId, civilAccountId: id });
            }
          });
        }
      });
      var option_detail = { options: opt_detail.sort((a, b) => (a.label ?? "").localeCompare((b.label ?? ""), undefined, { numeric: true, sensitivity: 'base' })) };
      civilBudgetDetailData.push(option_detail);
      setCivilBudgetDetailList(civilBudgetDetailData);
    }
    else {
      setCivilBudgetDetailList([]);
      setCivilBudgetList([]);
      setCiviList([]);
    }
  }, [civilBudgets, branchIdSelected]);

  useEffect(() => {
    if (!isEmpty(accAccounts)) {
      var data = [];
      var opt = [];
      accAccounts.forEach((item) => {
        const name = item.name;
        const code = item.code;
        const id = item.id;
        var obj = { label: code + " " + name, value: id };
        opt.push(obj);
      });
      var option = { options: opt.sort((a, b) => (a.label ?? "").localeCompare((b.label ?? ""), undefined, { numeric: true, sensitivity: "base" })) };
      data.push(option);
      setAccountingList(data);
    }
  }, [accAccounts]);

  useEffect(() => {
    var data = [];
    var opt = [];
    (branches || []).forEach((item) => {
      const name = item.name;
      const id = item.id;
      var obj = { label: name, value: id, companyId: item.companyId };
      opt.push(obj);
    });
    var option = { options: opt.sort((a, b) => (a.label ?? "").localeCompare((b.label ?? ""), undefined, { numeric: true, sensitivity: "base" })) };
    data.push(option);
    setBranchList(data);
  }, [branches]);

  useEffect(() => {
    if (!isEmpty(companies)) {
      var data = [];
      var opt = [];
      (companies || []).forEach((item) => {
        const name = item.name;
        const id = item.id;
        var obj = { label: name, value: id };
        opt.push(obj);
      });
      var option = { options: opt.sort((a, b) => (a.label ?? "").localeCompare((b.label ?? ""), undefined, { numeric: true, sensitivity: "base" })) };
      data.push(option);
      setCompanyList(data);
    }
  }, [companies]);

  useEffect(() => {
    if (!isEmpty(clients)) {
      var data = [];
      var opt = [];
      clients.forEach((item) => {
        const name = item.name;
        const id = item.id;
        var obj = { label: name, value: id };
        opt.push(obj);
      });
      var option = { options: opt.sort((a, b) => (a.label ?? "").localeCompare((b.label ?? ""), undefined, { numeric: true, sensitivity: "base" })) };
      data.push(option);
      setClientList(data);
    }
  }, [clients]);

  useEffect(() => {
    if (!isEmpty(info)) {
      let arrJob = [];
      let arrUnit = [];
      let ttlWeight = 0;
      let ttlAmount = 0;
      let ttlCompleted = 0;
      for (const acc of civilBudgets) {
        for (const account of acc.cvl_detail.sort((a, b) => a.cvld_account && b.cvld_account && a.cvld_account.sort_order - b.cvld_account.sort_order)) {
          if (account.type === "UPAH") {
            if (info.budget.length > 0) {
              if (info.budget.find((x) => x.civilAccountId === account.cvld_account.id)) {
                let weight = 0;
                let completed = 0;
                let amount = 0;
                let findJob = arrJob.findIndex(x => x.id === account.cvld_account.id);
                if (findJob === -1) {
                  for (const obj of info.unit) {
                    const findOpname = civilOpnames.filter((f) => f?.cvlop_product?.id === obj.value);
                    for (const detail of findOpname || []) {
                      let m = detail.checked_progress ? detail.checked_progress.split(",") : [];
                      let findAccount = m.indexOf(account.cvld_account.id.toString());
                      if (findAccount !== -1) {
                        weight += !isNaN(parseFloat(account.weight)) ? parseFloat(account.weight) : 0;
                        amount += !isNaN(parseFloat(account.amount)) ? parseFloat(account.amount) : 0;
                        completed += 1;
                      }
                    }
                  }
                  arrJob.push({ id: account.cvld_account.id, label: account?.cvld_account?.cvl_account_category?.name + " - " + account.cvld_account.name, weight_finished: weight, amount_finished: amount, amount: account.amount, weight: account.weight, completed: completed });
                } else {
                  for (const obj of info.unit) {
                    const findOpname = civilOpnames.filter((f) => f?.cvlop_product?.id === obj.value);
                    for (const detail of findOpname || []) {
                      let m = detail.checked_progress ? detail.checked_progress.split(",") : [];
                      let findAccount = m.indexOf(account.cvld_account.id.toString());
                      if (findAccount !== -1) {
                        weight += !isNaN(parseFloat(account.weight)) ? parseFloat(account.weight) : 0;
                        amount += !isNaN(parseFloat(account.amount)) ? parseFloat(account.amount) : 0;
                        completed += 1;
                      }
                    }
                  }
                  arrJob[findJob].weight_finished = parseFloat(arrJob[findJob].weight_finished) + weight;
                  arrJob[findJob].amount_finished = parseFloat(arrJob[findJob].amount_finished) + amount;
                  arrJob[findJob].completed = parseFloat(arrJob[findJob].completed) + completed;
                }
              }
            }
          }
        }
      }

      if (info.unit) {
        for (const obj of info.unit) {
          let weight = 0;
          let amount = 0;
          let amount_total = 0;
          let completed = 0;
          const findOpname = civilOpnames.filter((f) => f?.cvlop_product?.id === obj.value);
          for (const detail of findOpname || []) {
            let m = detail.checked_progress ? detail.checked_progress.split(",") : [];
            for (const acc of civilBudgets) {
              for (const account of acc.cvl_detail.sort((a, b) => a.cvld_account && b.cvld_account && a.cvld_account.sort_order - b.cvld_account.sort_order)) {
                if (account.type === "UPAH") {
                  let findAccount = m.indexOf(account.cvld_account.id.toString());
                  if (info.budget.length > 0) {
                    const findBudget = info.budget.find((x) => x.civilAccountId === account.cvld_account.id);
                    if (findAccount !== -1 && findBudget) {
                      weight += !isNaN(parseFloat(account.weight)) ? parseFloat(account.weight) : 0;
                      amount += !isNaN(parseFloat(account.amount)) ? parseFloat(account.amount) : 0;
                      completed += 1;
                    }
                    if (findBudget) amount_total += !isNaN(parseFloat(account.amount)) ? parseFloat(account.amount) : 0;
                  }
                }
              }
            }
          }
          ttlCompleted += completed;
          ttlWeight += weight;
          ttlAmount += amount;
          obj.weight = weight;
          obj.amount = amount;
          obj.amount_total = amount_total;
          obj.completed = completed;
          obj.joblist = info.budget.length;
          arrUnit.push(obj);
        }

        setProgressTotal(parseFloat(ttlWeight / info.unit.length).toFixed(2) || 0);
        setProgressPrice((parseFloat(ttlWeight / info.unit.length) / 100) * info.amount);
        setProgressUnitList(arrUnit)
        setJobList(arrJob);
      }
      else {
        setProgressTotal(0);
        setProgressUnitList([]);
        setJobList([]);
      }
    }
  }, [info, civilOpnames]);

  const reactToPrintContent = useCallback(() => {
    return printRef.current;
  }, [printRef]);

  const handleAfterPrint = useCallback(() => {
    // tslint:disable-line no-console
  }, []);

  const handleBeforePrint = useCallback(() => {
    // tslint:disable-line no-console
  }, []);

  const handleOnBeforeGetContent = useCallback(() => {
    setLoadingPrint(true);

    return new Promise((resolve) => {
      onBeforeGetContentResolve.current = resolve;

      setTimeout(() => {
        setLoadingPrint(false);
        resolve();
      }, 2000);
    });
  }, [setLoadingPrint]);

  const handlePrint = useReactToPrint({
    content: reactToPrintContent,
    documentTitle: "Task",
    onBeforeGetContent: handleOnBeforeGetContent,
    onBeforePrint: handleBeforePrint,
    onAfterPrint: handleAfterPrint,
    removeAfterPrint: true,
  });

  const onClickDelete = (civilContract) => {
    setCivilContract(civilContract);
    setDeleteModal(true);
  };

  const handleDeleteCivilContract = () => {
    if (civilContract) {
      dispatch(onDeleteCivilContract(civilContract));
      setDeleteModal(false);
    }
  };

  const toggleAccPayment = useCallback(() => {
    if (modalAccPayment) {
      setModalAccPayment(false);
    } else {
      setModalAccPayment(true);
    }
  }, [modalAccPayment]);

  const toggleAccPayable = useCallback(() => {
    if (modalAccPayable) {
      setModalAccPayable(false);
    } else {
      setModalAccPayable(true);
    }
  }, [modalAccPayable]);

  const toggleProgress = useCallback(() => {
    if (modalProgress) {
      setModalProgress(false);
    } else {
      setModalProgress(true);
    }
  }, [modalProgress]);

  const toggle = useCallback(() => {
    if (modal) {
      setModal(false);
      setCivilContract(null);
      setOriginalFiles([]);
      validation.resetForm();
    } else {
      setProductInventoryList([]);
      setModal(true);
    }
  }, [modal]);

  const toggleMedia = useCallback(() => {
    if (modalMedia) {
      setModalMedia(false);
    } else {
      setModalMedia(true);
    }
  }, [modalMedia]);

  const toggleApprove = useCallback(() => {
    if (modalApprove) {
      setModalApprove(false);
    } else {
      setModalApprove(true);
    }
  }, [modalApprove]);

  const toggleDetail = useCallback(() => {
    if (modalDetail) {
      setModalDetail(false);
      setCivilContract(null);
      setOriginalFiles([]);
    } else {
      setModalDetail(true);
    }
  }, [modalDetail]);

  const handleCivilContractClick = useCallback((arg, type, isEditData) => {
    const data = arg;
    let files = [];
    for (const f of data.cvl_contract_file) {
      files.push({ filename: f.filename, originalname: f.originalname });
    }
    setInvDocImg(files);
    setBranchIdSelected(data.branchId);

    let arrblock = [];
    if (data.block) {
      data.block.forEach((item) => {
        var obj = { label: item.label, value: item.value };
        arrblock.push(obj);
      });
    }

    let arrUnit = [];
    if (data.unit) {
      data.unit.forEach((item) => {
        var obj = { label: item.label, name: item.name, barcode: item.barcode, sku: item.sku, value: item.productId, price: item.price, brandId: item.brandId, productId: item.productId };
        arrUnit.push(obj);
      });
    }

    let arrBudget = [];
    if (data.budget) {
      data.budget.forEach((item) => {
        var obj = { label: item.label, value: item.value, category: item.category, civilAccountCategoryId: item.civilAccountCategoryId, civilBudgetId: item.civilBudgetId, civilBudgetDetailId: item.civilBudgetDetailId, civilAccountId: item.civilAccountId, amount: item.amount };
        arrBudget.push(obj);
      });
    }

    setCivilContract({
      id: data.id,
      code: data.code,
      transaction_no: data.transaction_no,
      transactionat: data.transactionat,
      description: data.description,
      amount: data.amount,
      cvl_budget: data.cvl_contract_cvl_budget && {
        label: data.cvl_contract_cvl_account ? data.cvl_contract_cvl_account.name : "",
        value: data.cvl_contract_cvl_account ? data.cvl_contract_cvl_account.id : "",
        civilAccountId: data.cvl_contract_cvl_account ? data.cvl_contract_cvl_account.id : "",
        civilBudgetDetailId: data.cvl_contract_cvl_budget.id,
        civilBudgetId: data.civilBudgetId,
      },
      civilBudgetId: data.civilBudgetId,
      civilBudgetDetailId: data.civilBudgetDetailId,
      paid_amount: data.paid_amount,
      payable_amount: data.payable_amount,
      civilAccountId: data.civilAccountId,
      cashflow: data.contract_budget && { label: data.contract_budget.name, value: data.contract_budget.id },
      startat: data.startat,
      endat: data.endat,
      unit: arrUnit.sort((a, b) => (a.label ?? "").localeCompare((b.label ?? ""), undefined, { numeric: true, sensitivity: "base" })),
      block: arrblock.sort((a, b) => (a.label ?? "").localeCompare((b.label ?? ""), undefined, { numeric: true, sensitivity: "base" })),
      budget: arrBudget.sort((a, b) => (a.label ?? "").localeCompare((b.label ?? ""), undefined, { numeric: true, sensitivity: "base" })),
      vendor: data.cvl_contract_vendor && {
        label: data.cvl_contract_vendor.name,
        value: data.cvl_contract_vendor.id,
      },
      client: data.cvl_contract_client && {
        label: data.cvl_contract_client.name,
        value: data.cvl_contract_client.id,
      },
      company: data.cvl_contract_company && {
        label: data.cvl_contract_company.name,
        value: data.cvl_contract_company.id,
      },
      branch: data.cvl_contract_branch && {
        label: data.cvl_contract_branch.name,
        value: data.cvl_contract_branch.id,
      },
      department: data.cvl_contract_department && {
        label: data.cvl_contract_department.name,
        value: data.cvl_contract_department.id,
      },
    });

    setIsEdit(isEditData);
    switch (type) {
      case "detail":
        toggleDetail();
        break;
      default:
        toggle();
        break;
    }
  }, [dispatch, toggleDetail, toggle]);

  function currencyFormat(num) {
    return parseFloat(num || 0).toLocaleString(["ban", "id"]);
  }

  const [isCheckAll, setIsCheckAll] = useState(false);
  const rowsRef = useRef([]);
  const checkedAll = () => {
    const allChecked = rowsRef.current.every((item) => item?.isChecked);
    const visibleIds = rowsRef.current.map((r) => String(r.id));

    const updated = civilContractList.map((item) => {
      const isVisible = visibleIds.includes(String(item.id));
      return isVisible ? { ...item, isChecked: !allChecked } : item;
    });
    setCivilContractList(updated);
    setIsCheckAll(allChecked);
  };

  const columns = useMemo(() => [{
    id: "#",
    width: 2,
    Header: <input type="checkbox" id="checkBoxAll" className="form-check-input" checked={isCheckAll} onChange={checkedAll} />,
    filterable: false,
    Cell: (cellProps) => {
      let data = cellProps.row.original;
      return (
        <input
          type="checkbox"
          className="dataCheckbox me-2 form-check-input"
          checked={data.isChecked}
          onChange={() => {
            const updatedData = civilContractList.map((d) => (d.id === data.id ? { ...d, isChecked: !d.isChecked } : d));
            setCivilContractList(updatedData);
          }} />
      );
    },
  },
  {
    Header: "No Kontrak",
    width: 50,
    accessor: "transaction_no",
    filterable: true,
    Cell: (cellProps) => {
      const data = cellProps.row.original;
      let arrBlock = [];
      for (const b of data.block) {
        arrBlock.push(b.value);
      }
      let vendor = data?.cvl_contract_vendor?.name;
      let stat;
      let statName = data?.cvl_contract_status?.name;
      switch (statName) {
        case "DRAFT":
          stat = <span className="badge text-uppercase badge-soft-warning">{statName}</span>;
          break;
        case "CONFIRMED":
          stat = <span className="badge text-uppercase badge-soft-info">{statName}</span>;
          break;
        case "PROCESSED":
          stat = <span className="badge text-uppercase badge-soft-primary">{statName}</span>;
          break;
        case "RECEIVED":
          stat = <span className="badge text-uppercase badge-soft-primary">{statName}</span>;
          break;
        case "COMPLETED":
          stat = <span className="badge text-uppercase badge-soft-success">{statName}</span>;
          break;
        default:
          stat = <span className="badge text-uppercase badge-soft-danger">{statName}</span>;
          break;
      }
      return (
        <div>
          <div className="mb-1 cursor-pointer"
            onClick={() => {
              setInfo(data);
              handleGetCivilOpname(arrBlock);
              setBranchIdSelected(data.branchId);
            }}>
            <div className="mb-1">
              <Link
                to="#"
                className="fw-semibold me-2">
                {data.transaction_no}
              </Link>
              <em>
                ({handleValidDate(data.startat)} - {handleValidDate(data.endat)})
              </em>
            </div>
            <div>
              <span className="fw-semibold fs-14">{vendor} </span>
              {stat}
              {data.hasPaid ? <span className="badge text-uppercase badge-soft-info">Paid</span> : <span className="badge text-uppercase badge-soft-warning">Unpaid</span>}
            </div>
            <div className="fs-18 ps-3 pe-2 mb-2 mt-2 text-break">
              {(data.block || []).map((obj, key) => {
                return (
                  <span key={key} className="badge me-1 mb-1 text-uppercase badge-soft-info">
                    {obj.label}
                  </span>
                );
              })}
            </div>
            <p className="mb-0 fw-semibold ms-3">{data?.cvl_contract_cvl_account?.name}</p>
            <ul className="mb-2 cursor-pointer">
              {(data.budget || []).map((item, key) => (
                <li key={key} className="m-0">
                  {item.label}
                </li>
              ))}
            </ul>
          </div>
          <div className="hstack gap-2 mt-2 mb-2">
            <ButtonGroup className="me-1">
              <UncontrolledButtonDropdown>
                <Button
                  color="light"
                  className="btn-sm"
                  onClick={() => {
                    handleCivilContractClick(data, "detail", false);
                    setInfo(data);
                    setPrintType();
                    setModalDetail(true);
                  }}>
                  <i className="ri-printer-line text-info fs-15"></i>
                </Button>
                <Button
                  color="light"
                  className="btn-sm"
                  onClick={() => {
                    handleCivilContractClick(data, "detail", false);
                    setInfo(data);
                    setPrintType("spk");
                    setModalDetail(true);
                  }}>
                  <i className="ri-printer-line text-success fs-15"></i>
                </Button>
                <Button
                  color="light"
                  className={userType === "admin" || userType === "client" || userType === "company" ? "btn-sm" : userRole && userRole.split(",").indexOf("createCivilContract") !== -1 ? "btn-sm" : "btn-sm d-none"}
                  onClick={() => {
                    handleCivilContractClick(data, "", false);
                  }}>
                  <i className="ri-file-copy-line fs-15"></i>
                </Button>
                <Button
                  color="light"
                  className="btn-sm"
                  onClick={() => {
                    handleCivilContractClick(data, "", true);
                  }}>
                  <i className="ri-edit-2-line fs-15"></i>
                </Button>
                {(data.statusId === 1 || userType === "admin") && <Button
                  color="light"
                  className="btn-sm"
                  onClick={() => {
                    onClickDelete(data);
                  }}>
                  <i className="ri-delete-bin-line fs-15 text-danger"></i>
                </Button>}
              </UncontrolledButtonDropdown>
            </ButtonGroup>
            {/* {data.paid_amount > 0 && (
              <button
                className="btn-label btn btn-sm btn-soft-success fs-12 me-0"
                onClick={() => {
                  data.statusCivilContractId = 2;
                  setCivilContract(data);
                  toggleApprove();
                }}>
                <i className="ri-checkbox-circle-line label-icon align-middle fs-16 me-1"></i> APPROVE
              </button>
            )} */}
          </div>
        </div>
      );
    },
  },
  {
    id: "Proyek",
    Header: "Proyek",
    accessor: "cvl_contract_branch.branch_name",
    filterable: true,
  },
  {
    id: "Harga",
    Header: <div className="text-end pe-3">Harga</div>,
    width: 12,
    accessor: "amount",
    filterable: true,
    Cell: (data) => {
      return <div className="text-end">{currencyFormat(data.row.original.amount)}</div>;
    },
  },
  {
    id: "Tagihan",
    Header: <div className="text-end pe-3">Tagihan</div>,
    width: 12,
    accessor: "payable_amount",
    filterable: true,
    Cell: (data) => {
      return <div className="fw-semibold text-warning text-end">{currencyFormat(parseFloat(data.row.original.payable_amount || 0))}</div>;
    },
  },
  {
    id: "Terbayar",
    Header: <div className="text-end pe-3">Terbayar</div>,
    width: 12,
    accessor: "paid_amount",
    filterable: true,
    Cell: (data) => {
      return <div className="fw-semibold text-success text-end">{currencyFormat(parseFloat(data.row.original.paid_amount || 0))}</div>;
    },
  },
  {
    id: "SisaBayar",
    Header: <div className="text-end pe-3">Sisa Bayar</div>,
    width: 12,
    accessor: (data) => parseFloat(data.amount) - parseFloat(data.paid_amount || 0),
    filterable: true,
    Cell: (data) => {
      return <div className="fw-semibold text-danger text-end">{currencyFormat(parseFloat(data.row.original.amount) - parseFloat(data.row.original.paid_amount || 0))}</div>;
    },
  },
  {
    id: "NamaProyek",
    Header: "NamaProyek",
    accessor: "cvl_contract_branch.name",
    filterable: true,
  },
  {
    id: "KodeProyek",
    Header: "KodeProyek",
    accessor: "cvl_contract_branch.branch_code",
    filterable: true,
  },
  {
    id: "Pekerjaan",
    Header: "Pekerjaan",
    accessor: "cvl_contract_account.name",
    filterable: true,
  },
  {
    id: "Suplier",
    Header: "Suplier",
    accessor: "cvl_contract_vendor.name",
    filterable: true,
  },
  {
    id: "Tanggal_Kontrak",
    Header: "Tanggal Kontrak",
    accessor: "startat",
    filterable: true,
  },
  {
    id: "Tanggal_Berakhir",
    Header: "Tanggal Berakhir",
    accessor: "endat",
    filterable: true,
    Cell: (client) => <>{handleValidDate(client.row.original.endat)}</>,
  },
  {
    id: "Status",
    Header: "Status",
    accessor: "cvl_contract_status.name",
    filterable: true,
    Cell: (cell) => {
      switch (cell.value) {
        case "DRAFT":
          return <span className="badge text-uppercase badge-soft-warning">{cell.value}</span>;
        case "ACTIVE":
          return <span className="badge text-uppercase badge-soft-secondary">{cell.value}</span>;
        case "INACTIVE":
          return <span className="badge text-uppercase badge-soft-info">{cell.value}</span>;
        default:
          return <span className="badge text-uppercase badge-soft-danger">{cell.value}</span>;
      }
    },
  }], [civilContractList, handleCivilContractClick, toggleApprove, isCheckAll]);

  const [globalFilterValue, setGlobalFilterValue] = useState("");
  const onChange = useAsyncDebounce((value) => {
    const resetChecked = civilContractList.map((item) => ({
      ...item,
      isChecked: false,
    }));
    setCivilContractList(resetChecked);
    setIsCheckAll(false);
    setGlobalFilter(value || undefined);
    setGlobalFilterValue(value ?? "");
  }, 300);

  const memoizedData = useMemo(() => civilContractList, [civilContractList]);

  const {
    getTableProps,
    rows,
    getTableBodyProps,
    headerGroups,
    page,
    prepareRow,
    canPreviousPage,
    canNextPage,
    pageOptions,
    gotoPage,
    nextPage,
    previousPage,
    setPageSize,
    preGlobalFilteredRows,
    setGlobalFilter,
    state: { pageIndex, pageSize },
  } = useTable(
    {
      columns: columns,
      data: memoizedData,
      defaultColumn: { Filter: null },
      initialState: {
        hiddenColumns: ["Status", "Tanggal_Berakhir", "NamaProyek", "Pekerjaan", "Proyek", "KodeProyek", "Suplier", "Tanggal_Kontrak"],
        pageIndex: 0,
        pageSize: 10,
        selectedRowIds: 0,
        sortBy: [
          {
            id: "Tanggal",
            desc: true,
          },
        ],
        globalFilter: globalFilterValue,
      },
    },
    useGlobalFilter,
    useFilters,
    useSortBy,
    useExpanded,
    usePagination,
    useRowSelect
  );

  useEffect(() => {
    const currentRows = rows.map((r) => r.original);
    rowsRef.current = currentRows;
    const allChecked = currentRows.length > 0 && currentRows.every((item) => item.isChecked);
    setIsCheckAll(allChecked);
  }, [rows]);

  const generateSortingIndicator = (column) => {
    return column.isSorted ? (column.isSortedDesc ? " " : "") : "";
  };

  const generateFilterable = (column) => {
    return column.filterable ? (column.isSorted ? (column.isSortedDesc ? " sorting_desc" : " sorting_asc") : " sort") : "";
  };

  const onChangeInSelect = (event) => {
    setPageSize(Number(event.target.value));
  };

  const onChangeInInput = (event) => {
    const page = event.target.value ? Number(event.target.value) - 1 : 0;
    gotoPage(page);
  };

  const countSearch = preGlobalFilteredRows.length;
  const [searchValue, setSearchValue] = useState("");

  function handleFilter() {
    let startat = "";
    let endat = "";
    let datearr = filterDate?.split(" to ");
    if (datearr) {
      startat = datearr[0];
      endat = datearr[1] ? datearr[1] : datearr[0];
    }

    var status = statusCivilContract.value ? statusCivilContract.value : "";
    const param = {
      title: searchValue,
      startat: startat,
      endat: endat,
      status: status,
      branchId: branchSelected.value ?? "",
      type: "requested",
    };
    dispatch(onGetCivilContracts(param));
  }

  function handleResetFilter() {
    setFilterDate(null);
    setSearchValue("");
    handleGetCivilContract(companySelected.value, branchSelected.value);
  }

  const validationApprove = useFormik({
    enableReinitialize: true,
    initialValues: {
      approval_note: "",
    },
    onSubmit: (values) => {
      if (civilContract) {
        civilContract.setApprove = true;
        civilContract.approval_note = values.approval_note;
        dispatch(onUpdateCivilContract(civilContract));
      }
      validationApprove.resetForm();
      toggleApprove();
    },
  });

  const validationAccPayment = useFormik({
    enableReinitialize: true,
    initialValues: {
      amount: (info && info.amount - info.paid_amount) || 0,
      account: "",
      transactionat: moment().format("YYYY/MM/DD"),
    },
    validationSchema: Yup.object({
      amount: Yup.string().required("Please Pick Amount")
    }),
    onSubmit: (values) => {
      dispatch(getCivilContractLoading());
      if (info && info.code) {
        info.setAccPayment = true;
        info.setApprove = false;
        info.accPaymentId = values.account.value;
        info.transactionat = values.transactionat;
        info.civilAccountId = info.civilAccountId || null;
        info.civilBudgetId = info.civilBudgetId || null;
        info.civilBudgetDetailId = info.civilBudgetDetailId || null;
        info.budgetId = info.budgetId || null;
        info.vendorId = info.vendorId || null;
        info.accType = "CASH OUT";
        info.description = `PEMBAYARAN SPK (${info.cvl_contract_vendor.name} #${info.code})`;
        info.amount = values.amount;
        dispatch(onUpdateCivilContract(info));
      }
      else {
        toast.error("No SPK hilang dari memory browser coba klik ulang tombol pembayaran", { position: "bottom-left", autoClose: 5000 });
      }
      validationAccPayment.resetForm();
      toggleAccPayment();
    },
  });

  const validationAccPayable = useFormik({
    enableReinitialize: true,
    initialValues: {
      amount: Math.round(progressPrice) - parseFloat(info?.payable_amount || 0) || 0,
      account: "",
      paymentMethod: "",
      description: "",
      transactionat: moment().format("YYYY/MM/DD"),
    },
    validationSchema: Yup.object({
      amount: Yup.string().required("Please Pick Amount"),
      paymentMethod: Yup.object().required("Please Select Payment Method").nullable(true),
    }),
    onSubmit: (values) => {
      dispatch(getCivilContractLoading());
      if (info && info.code) {
        info.setAccPayable = true;
        info.setApprove = false;
        info.transactionat = values.transactionat;
        info.paymentMethodId = values.paymentMethod.value;
        info.civilAccountId = info.civilAccountId || null;
        info.civilBudgetId = info.civilBudgetId || null;
        info.civilBudgetDetailId = info.civilBudgetDetailId || null;
        info.budgetId = info.budgetId || null;
        info.vendorId = info.vendorId || null;
        info.accType = "PAYABLE";
        info.description = `UPAH PRODUKSI BORONGAN (${info.cvl_contract_vendor.name} #${info.code}) ${values.description}`;
        info.amount = values.amount;
        dispatch(onUpdateCivilContract(info));
      }
      else {
        toast.error("No SPK hilang dari memory browser coba klik ulang tombol tagihan", { position: "bottom-left", autoClose: 5000 });
      }
      validationAccPayable.resetForm();
      toggleAccPayable();
    },
  });

  const validation = useFormik({
    enableReinitialize: true,
    initialValues: {
      client: (civilContract && civilContract.client) || clientSelected,
      company: (civilContract && civilContract.company) || companySelected,
      department: (civilContract && civilContract.department) || departmentSelect,
      startat: (civilContract && civilContract.startat) ?? "",
      endat: (civilContract && civilContract.endat) ?? "",
      id: (civilContract && civilContract.id) || 0,
      description: (civilContract && civilContract.description) ?? "",
      vendor: (civilContract && civilContract.vendor) ?? "",
      amount: (civilContract && civilContract.amount) || null,
      branch: (civilContract && civilContract.branch) || (branchSelected?.value === "all" ? "" : branchSelected),
      block: (civilContract && civilContract.block) ?? "",
      unit: (civilContract && civilContract.unit) ?? "",
      budget: (civilContract && civilContract.budget) ?? "",
      cvl_budget: (civilContract && civilContract.cvl_budget) ?? "",
      cashflow: (civilContract && civilContract.cashflow) ?? "",
      paid_amount: (civilContract && civilContract.paid_amount) || 0,
      payable_amount: (civilContract && civilContract.payable_amount) || 0,
    },
    validationSchema: Yup.object({
      branch: Yup.object().required("Silahkan isi Cabang").nullable(true),
      cashflow: Yup.object().required("Silahkan isi Anggaran Cashflow").nullable(true),
      cvl_budget: Yup.object().required("Silahkan isi Anggaran").nullable(true),
      vendor: Yup.object().required("Silahkan isi Vendor").nullable(true),
      company: Yup.object().required("Silahkan isi perusahaan").nullable(true),
      client: Yup.object().required("Silahkan isi grup perusahaan").nullable(true),
    }),
    onSubmit: (values) => {
      if (isEdit) {
        let dataEdit = {
          id: values.id,
          description: values.description,
          paid_amount: values.paid_amount,
          payable_amount: values.payable_amount,
          clientId: values.client.value,
          startat: values.startat,
          endat: values.endat,
          budgetId: values.cashflow.value,
          companyId: values.company.value,
          civilAccountId: values.cvl_budget.civilAccountId || null,
          civilBudgetId: values.cvl_budget.civilBudgetId || null,
          civilBudgetDetailId: values.cvl_budget.civilBudgetDetailId || null,
          departmentId: values.department.value,
          budget: values.budget,
          branchId: values.branch.value,
          vendorId: values.vendor.value,
          amount: values.amount,
          unit: values.unit,
          block: values.block,
          files: invDocImg.length > 0 ? invDocImg : [],
        };
        dispatch(onUpdateCivilContract(dataEdit));
        toggle();
      } else {
        let dataSubmit = {
          description: values.description,
          paid_amount: 0,
          payable_amount: 0,
          clientId: values.client.value,
          companyId: values.company.value,
          budgetId: values.cashflow.value,
          civilAccountId: values.cvl_budget.civilAccountId || null,
          civilBudgetId: values.cvl_budget.civilBudgetId || null,
          civilBudgetDetailId: values.cvl_budget.civilBudgetDetailId || null,
          departmentId: values.department.value,
          startat: values.startat,
          endat: values.endat,
          budget: values.budget,
          branchId: values.branch.value,
          vendorId: values.vendor.value,
          amount: values.amount,
          unit: values.unit,
          block: values.block,
          files: invDocImg.length > 0 ? invDocImg : [],
        };

        dispatch(onAddNewCivilContract(dataSubmit));
        toggle();
      }
      validation.resetForm();
    },
  });

  const deleteMultiple = () => {
    const ele = document.querySelectorAll(".dataCheckbox:checked");
    const checkall = document.getElementById("checkBoxAll");
    ele.forEach((element) => {
      dispatch(onDeleteCivilContract(element.value));
    });
    checkall.checked = false;
  };

  const handleDeleteFile = (file) => {
    if (isEdit) {
      const newState = invDocImg.map((obj) => {
        if (obj.filename === file.filename) {
          return { filename: file.filename, isDeleted: true };
        }
        return obj;
      });
      setInvDocImg(newState);
    } else {
      const index = invDocImg.findIndex((fl) => fl.filename === file.filename);
      setInvDocImg((val) => [...val.slice(0, index), ...val.slice(index + 1)]);
    }
  };

  const handleSelectFile = (file) => {
    setInvDocImg((val) => [...val, { filename: file.filename, originalname: file.originalname }]);
    toggleMedia();
  };

  useEffect(() => {
    const checkall = document.getElementById("checkBoxAllInventory");
    const resultF = productInventoryList.every((el) => el.checked !== true);
    if (checkall !== null) {
      if (resultF) {
        checkall.checked = false;
      }
    }
  }, [productInventoryList]);

  const validValue = (val) => {
    return <span className="courier text-capitalize">{`${val || "..................."}`}</span>;
  };

  const terbilang = (angka) => {
    const bilangan = [
      "", "Satu", "Dua", "Tiga", "Empat", "Lima", "Enam", "Tujuh", "Delapan", "Sembilan", "Sepuluh", "Sebelas"
    ];

    let temp = "";
    if (angka < 12) {
      temp = " " + bilangan[angka];
    } else if (angka < 20) {
      temp = terbilang(angka - 10) + " Belas";
    } else if (angka < 100) {
      temp = terbilang(Math.floor(angka / 10)) + " Puluh " + terbilang(angka % 10);
    } else if (angka < 200) {
      temp = " Seratus " + terbilang(angka - 100);
    } else if (angka < 1000) {
      temp = terbilang(Math.floor(angka / 100)) + " Ratus " + terbilang(angka % 100);
    } else if (angka < 2000) {
      temp = " Seribu " + terbilang(angka - 1000);
    } else if (angka < 1000000) {
      temp = terbilang(Math.floor(angka / 1000)) + " Ribu " + terbilang(angka % 1000);
    }

    return temp.trim();
  };

  // Fungsi utama formatter tanggal
  const formatTanggalIndonesia = (dateString) => {
    if (!dateString) return "";

    // Memecah input "dd/mm/yyyy"
    const parts = dateString.split('/');
    if (parts.length !== 3) return "Format tidak valid. Gunakan dd/mm/yyyy";

    const dayStr = parts[0];
    const monthStr = parts[1];
    const yearStr = parts[2];

    const day = parseInt(dayStr, 10);
    const month = parseInt(monthStr, 10);
    const year = parseInt(yearStr, 10);

    // Validasi JS Date (Bulan di JS Date dimulai dari 0 = Januari)
    const dateObj = new Date(year, month - 1, day);

    // Array terjemahan
    const days = ["Minggu", "Senin", "Selasa", "Rabu", "Kamis", "Jumat", "Sabtu"];
    const months = [
      "Januari", "Februari", "Maret", "April", "Mei", "Juni",
      "Juli", "Agustus", "September", "Oktober", "November", "Desember"
    ];

    const dayName = days[dateObj.getDay()];
    const monthName = months[month - 1];

    const dayText = terbilang(day);
    const yearText = terbilang(year); // Output "Dua Ribu Dua Puluh Enam" untuk 2026

    // Menyusun output akhir
    return `${dayName}, Tanggal ${dayText}, Bulan ${monthName}, Tahun ${yearText} (${dayStr}-${monthStr}-${yearStr})`;
  };

  function numberToWords(input) {
    const number = Number(input);

    if (isNaN(number)) {
      return "Input harus angka yang valid (contoh: 6500000 atau '6500000')";
    }

    if (number < 0) {
      return "Input harus non-negatif";
    }

    const num = Math.floor(number);

    if (num === 0) {
      return "Nol Rupiah";
    }

    const satuan = ["", "Satu", "Dua", "Tiga", "Empat", "Lima", "Enam", "Tujuh", "Delapan", "Sembilan"];
    const belasan = ["Sepuluh", "Sebelas", "Dua Belas", "Tiga Belas", "Empat Belas", "Lima Belas", "Enam Belas", "Tujuh Belas", "Delapan Belas", "Sembilan Belas"];
    const puluhan = ["", "", "Dua Puluh", "Tiga Puluh", "Empat Puluh", "Lima Puluh", "Enam Puluh", "Tujuh Puluh", "Delapan Puluh", "Sembilan Puluh"];
    const skala = ["", "Ribu", "Juta", "Miliar", "Triliun", "Kuadriliun", "Kuintiliun"];

    function convertLessThanThousand(n) {
      if (n === 0) return "";
      if (n < 10) return satuan[n];
      if (n < 20) return belasan[n - 10];
      if (n < 100) {
        const p = puluhan[Math.floor(n / 10)];
        const s = satuan[n % 10];
        return p + (s ? " " + s : "");
      }
      const ratus = satuan[Math.floor(n / 100)];
      const sisa = n % 100;
      let hasil = ratus + " Ratus";
      if (sisa > 0) hasil += " " + convertLessThanThousand(sisa);
      return hasil;
    }

    let parts = [];
    let temp = num;
    while (temp > 0) {
      parts.push(temp % 1000);
      temp = Math.floor(temp / 1000);
    }

    let result = [];
    for (let i = parts.length - 1; i >= 0; i--) {
      const val = parts[i];
      if (val === 0) continue;

      let chunk = convertLessThanThousand(val);
      if (i > 0) {
        chunk += " " + skala[i];
      }
      if (chunk) result.push(chunk);
    }

    let final = result.join(" ");

    final = final.replace(/^Satu Ribu\b/, "Seribu");

    final = final.replace(/^Satu Juta\b/, "Sejuta");

    final = final.replace(/Satu Ratus(?=.*(Juta|Miliar|Triliun|Kuadriliun|Kuintiliun))/g, "Seratus");

    return final + " Rupiah";
  }

  document.title = "Surat Tugas | Enterprise Resources Planning";

  return (
    <div className="page-content">
      <ExportCSVModal show={isExportCSV} onCloseClick={() => setIsExportCSV(false)} data={civilContractList} />
      <DeleteModal show={deleteModal} onDeleteClick={handleDeleteCivilContract} onCloseClick={() => setDeleteModal(false)} />
      <DeleteModal
        show={deleteModalMulti}
        onDeleteClick={() => {
          deleteMultiple();
          setDeleteModalMulti(false);
        }}
        onCloseClick={() => setDeleteModalMulti(false)} />
      <Container fluid>
        <BreadCrumb title="Teknik" pageTitle="Surat Tugas" loading={loading || civilOpnameLoading}>
          <div className="flex-shrink-0">
            <button
              type="button"
              className={userType === "admin" || userType === "client" || userType === "company" ? "btn btn-primary add-btn me-2" : userRole && userRole.split(",").indexOf("createCivilContract") !== -1 ? "btn btn-primary add-btn me-2" : "d-none"}
              id="create-btn"
              onClick={() => {
                setIsEdit(false);
                toggle();
              }}>
              <i className="ri-add-line me-1 align-bottom fs-14"></i> TAMBAH
            </button>
            <ExportDoc data={civilContractDoc} />
          </div>
        </BreadCrumb>
        <Row>
          <Col xl={3} md={6}>
            <Card className="card-animate">
              <CardBody>
                <div className="d-flex align-items-center">
                  <div className="flex-grow-1"><p className="text-uppercase fw-medium text-muted mb-0">TOTAL NILAI SURAT TUGAS</p></div>
                  <div className="flex-shrink-0">
                  </div>
                </div>
                <div className="d-flex align-items-end justify-content-between mt-1">
                  <div>
                    <h4 className="fs-22 fw-semibold ff-secondary mb-2">
                      <CountUp start={0}
                        separator="."
                        decimal=","
                        prefix=""
                        decimals=""
                        end={(civilContractList || []).reduce((a, v) => (a = a + parseFloat(v.amount || 0)), 0)}
                        duration={1}
                        className="counter-value" />
                    </h4>
                    <span className="badge bg-info me-2">{(civilContractList || []).length}</span>
                    <span className="text-muted">Transaksi</span>
                  </div>
                  <div className="avatar-xs flex-shrink-0"><span className="avatar-title bg-light rounded fs-3"><FeatherIcon icon="book" className="text-success icon-dual-success" /></span></div>
                </div>
              </CardBody>
            </Card>
          </Col>
          <Col xl={3} md={6}>
            <Card className="card-animate">
              <CardBody>
                <div className="d-flex align-items-center">
                  <div className="flex-grow-1"><p className="text-uppercase fw-medium text-muted mb-0">MENUNGGU OPNAME</p></div>
                  <div className="flex-shrink-0"><h5 className={(civilContractList || []).reduce((a, v) => (a = a + (parseFloat(v.amount || 0) - parseFloat(v.payable_amount || 0))), 0) / (civilContractList || []).reduce((a, v) => (a = a + parseFloat(v.amount || 0)), 0) * 100 > 50 ? "fs-14 mb-0 text-success" : "fs-14 mb-0 text-warning"}> <i className={(civilContractList || []).reduce((a, v) => (a = a + (parseFloat(v.amount || 0) - parseFloat(v.payable_amount || 0))), 0) / (civilContractList || []).reduce((a, v) => (a = a + parseFloat(v.amount || 0)), 0) * 100 > 50 ? "ri-arrow-right-up-line fs-13 me-2 align-middle" : "ri-arrow-right-down-line fs-13 me-2 align-middle"}></i> {parseFloat((civilContractList || []).reduce((a, v) => (a = a + (parseFloat(v.amount || 0) - parseFloat(v.payable_amount || 0))), 0) / (civilContractList || []).reduce((a, v) => (a = a + parseFloat(v.amount || 0)), 0) * 100).toFixed(2)} %</h5>
                  </div>
                </div>
                <div className="d-flex align-items-end justify-content-between mt-1">
                  <div>
                    <h4 className="fs-22 fw-semibold ff-secondary mb-2">
                      <CountUp start={0}
                        separator="."
                        decimal=","
                        prefix=""
                        decimals=""
                        end={(civilContractList || []).reduce((a, v) => (a = a + (parseFloat(v.amount || 0) - parseFloat(v.payable_amount || 0))), 0)}
                        duration={1}
                        className="counter-value" />
                    </h4>
                    <span className="badge bg-info me-2">{(civilContractList || []).filter(f => (parseFloat(f.amount || 0) - parseFloat(f.payable_amount || 0)) > 0).length}</span>
                    <span className="text-muted">Transaksi</span>
                  </div>
                  <div className="avatar-xs flex-shrink-0"><span className="avatar-title bg-light rounded fs-3"><FeatherIcon icon="file-text" className="text-success icon-dual-success" /></span></div>
                </div>
              </CardBody>
            </Card>
          </Col>
          <Col xl={3} md={6}>
            <Card className="card-animate">
              <CardBody>
                <div className="d-flex align-items-center">
                  <div className="flex-grow-1"><p className="text-uppercase fw-medium text-muted mb-0">TERBAYAR</p></div>
                  <div className="flex-shrink-0"><h5 className={(civilContractList || []).reduce((a, v) => (a = a + (parseFloat(v.paid_amount || 0))), 0) / (civilContractList || []).reduce((a, v) => (a = a + parseFloat(v.amount || 0)), 0) * 100 > 50 ? "fs-14 mb-0 text-success" : "fs-14 mb-0 text-warning"}> <i className={(civilContractList || []).reduce((a, v) => (a = a + (parseFloat(v.paid_amount || 0))), 0) / (civilContractList || []).reduce((a, v) => (a = a + parseFloat(v.amount || 0)), 0) * 100 > 50 ? "ri-arrow-right-up-line fs-13 me-2 align-middle" : "ri-arrow-right-down-line fs-13 me-2 align-middle"}></i> {parseFloat((civilContractList || []).reduce((a, v) => (a = a + (parseFloat(v.paid_amount || 0))), 0) / (civilContractList || []).reduce((a, v) => (a = a + parseFloat(v.amount || 0)), 0) * 100).toFixed(2)} %</h5></div>
                </div>
                <div className="d-flex align-items-end justify-content-between mt-1">
                  <div>
                    <h4 className="fs-22 fw-semibold ff-secondary mb-2">
                      <CountUp start={0}
                        separator="."
                        decimal=","
                        prefix=""
                        decimals=""
                        end={(civilContractList || []).reduce((a, v) => (a = a + parseFloat(v.paid_amount || 0)), 0)}
                        duration={1}
                        className="counter-value" />
                    </h4>
                    <span className="badge bg-info me-2">{(civilContractList || []).filter(f => parseFloat(f.paid_amount) > 0).length}</span>
                    <span className="text-muted">Transaksi</span>
                  </div>
                  <div className="avatar-xs flex-shrink-0"><span className="avatar-title bg-light rounded fs-3"><FeatherIcon icon="check-square" className="text-success icon-dual-success" /></span></div>
                </div>
              </CardBody>
            </Card>
          </Col>
          <Col xl={3} md={6}>
            <Card className="card-animate">
              <CardBody>
                <div className="d-flex align-items-center">
                  <div className="flex-grow-1"><p className="text-uppercase fw-medium text-muted mb-0">MENUNGGU BAYAR</p></div>
                  <div className="flex-shrink-0"><h5 className={(civilContractList || []).reduce((a, v) => (a = a + (parseFloat(v.amount || 0) - parseFloat(v.paid_amount || 0))), 0) / (civilContractList || []).reduce((a, v) => (a = a + parseFloat(v.amount || 0)), 0) * 100 > 50 ? "fs-14 mb-0 text-success" : "fs-14 mb-0 text-warning"}> <i className={(civilContractList || []).reduce((a, v) => (a = a + (parseFloat(v.amount || 0) - parseFloat(v.paid_amount || 0))), 0) / (civilContractList || []).reduce((a, v) => (a = a + parseFloat(v.amount || 0)), 0) * 100 > 50 ? "ri-arrow-right-up-line fs-13 me-2 align-middle" : "ri-arrow-right-down-line fs-13 me-2 align-middle"}></i> {parseFloat((civilContractList || []).reduce((a, v) => (a = a + (parseFloat(v.amount || 0) - parseFloat(v.paid_amount || 0))), 0) / (civilContractList || []).reduce((a, v) => (a = a + parseFloat(v.amount || 0)), 0) * 100).toFixed(2)} %</h5>
                  </div>
                </div>
                <div className="d-flex align-items-end justify-content-between mt-1">
                  <div>
                    <h4 className="fs-22 fw-semibold ff-secondary mb-2">
                      <CountUp start={0}
                        separator="."
                        decimal=","
                        prefix=""
                        decimals=""
                        end={(civilContractList || []).reduce((a, v) => (a = a + (parseFloat(v.amount || 0) - parseFloat(v.paid_amount || 0))), 0)}
                        duration={1}
                        className="counter-value" />
                    </h4>
                    <span className="badge bg-info me-2">{(civilContractList || []).filter(f => (parseFloat(f.amount || 0) - parseFloat(f.paid_amount || 0)) > 0).length}</span>
                    <span className="text-muted">Transaksi</span>
                  </div>
                  <div className="avatar-xs flex-shrink-0"><span className="avatar-title bg-light rounded fs-3"><FeatherIcon icon="clock" className="text-success icon-dual-success" /></span></div>
                </div>
              </CardBody>
            </Card>
          </Col>
        </Row>
        <Row>
          <Col lg={12}>
            <Card>
              <CardBody className="pt-1 mb-0 pb-0">
                <Nav className="nav-tabs nav-tabs-custom nav-success" role="tablist">
                  <NavItem>
                    <NavLink
                      className={classnames({ active: activeTab === "1" }, "fw-semibold")}
                      onClick={() => {
                        setView("opname");
                        toggleTab("1", "all");
                      }} href="#">
                      <i className="ri-article-line me-1 align-bottom fs-14"></i> OPNAME SURAT TUGAS
                    </NavLink>
                  </NavItem>
                  <NavItem>
                    <NavLink
                      className={classnames({ active: activeTab === "5" }, "fw-semibold")}
                      onClick={() => {
                        setView("summary");
                        toggleTab("5", "all");
                      }} href="#">
                      <i className="ri-file-list-3-line me-1 align-bottom fs-14"></i> REKAP / SUPPLIER
                    </NavLink>
                  </NavItem>
                  <NavItem>
                    <NavLink
                      className={classnames({ active: activeTab === "6" }, "fw-semibold")}
                      onClick={() => {
                        setView("summaryjob");
                        toggleTab("6", "all");
                      }} href="#">
                      <i className="ri-file-list-3-line me-1 align-bottom fs-14"></i> REKAP / PEKERJAAN
                    </NavLink>
                  </NavItem>
                  <NavItem>
                    <NavLink
                      className={classnames({ active: activeTab === "7" }, "fw-semibold")}
                      onClick={() => {
                        setView("summaryjobsupplier");
                        toggleTab("7", "all");
                      }} href="#">
                      <i className="ri-file-list-3-line me-1 align-bottom fs-14"></i> REKAP / PEKERJAAN / SUPPLIER
                    </NavLink>
                  </NavItem>
                  <NavItem>
                    <NavLink
                      className={classnames({ active: activeTab === "2" }, "fw-semibold")}
                      onClick={() => {
                        setView("opname");
                        toggleTab("2", "DRAFT");
                      }} href="#">
                      <i className="ri-information-line me-1 align-bottom fs-14"></i> DRAFT
                    </NavLink>
                  </NavItem>
                  <NavItem>
                    <NavLink
                      className={classnames({ active: activeTab === "3" }, "fw-semibold")}
                      onClick={() => {
                        toggleTab("3", "ACTIVE");
                        setView("opname");
                      }} href="#">
                      <i className="ri-checkbox-circle-line me-1 align-bottom fs-14"></i> ACTIVE
                    </NavLink>
                  </NavItem>
                  <NavItem>
                    <NavLink
                      className={classnames({ active: activeTab === "4" }, "fw-semibold")}
                      onClick={() => {
                        toggleTab("4", "INACTIVE");
                        setView("opname");
                      }} href="#">
                      <i className="ri-close-circle-line me-1 align-bottom fs-14"></i> INACTIVE
                    </NavLink>
                  </NavItem>
                </Nav>
                <Row className="mb-0" >
                  <CardBody className="border border-top-0 border-end-0 border-start-0 pb-0">
                    <Row>
                      <Col sm={1}>
                        <div className="me-2 mb-3 col-12">
                          <select className="form-select" value={pageSize} onChange={onChangeInSelect}>
                            {[10, 25, 50, 100, 150, 250, 500, 1000, 2500, 5000].map((pageSize) => (
                              <option key={pageSize} value={pageSize}>
                                {pageSize}
                              </option>
                            ))}
                          </select>
                        </div>
                      </Col>
                      <Col sm={3}>
                        <div className="search-box me-2 mb-3 d-inline-block col-12">
                          <input
                            id="search-bar-0"
                            type="text"
                            className="form-control search"
                            onChange={(e) => {
                              setSearchValue(e.target.value);
                              onChange(e.target.value);
                              gotoPage(0);
                            }}
                            placeholder={`${countSearch} Cari...`}
                            value={searchValue ?? ""} />
                          <i className="bx bx-search-alt search-icon"></i>
                        </div>
                      </Col>
                      <Col sm={3}>
                        <Select
                          name="searchBudget"
                          value={searchBudget}
                          placeholder="Filter Anggaran"
                          onChange={(e) => {
                            toggleTab(e.value, "budget");
                            setSearchBudget(e);
                          }}
                          options={civilList}></Select>
                      </Col>
                      <Col sm={3}>
                        <div className="search-box me-2 mb-3 col-12">
                          <Flatpickr
                            className="form-control"
                            id="datepicker-publish-input"
                            placeholder="Pilih Tanggal"
                            options={{
                              mode: "range",
                              dateFormat: "Y/m/d",
                            }}
                            onChange={(selectedDates, dateStr) => {
                              setFilterDate(dateStr);
                            }} />
                          <i className="bx bx-calendar-alt search-icon"></i>
                        </div>
                      </Col>
                      <Col sm={2}>
                        <div className="hstack gap-2">
                          <button
                            type="button"
                            className="btn btn-icon btn-md btn-soft-success waves-effect waves-light material-shadow-none w-100 fw-semibold"
                            onClick={() => {
                              handleFilter();
                            }}>
                            <i className="ri-search-line align-bottom fs-16"></i>
                          </button>
                          <button
                            type="button"
                            className="btn btn-icon btn-md btn-soft-info waves-effect waves-light material-shadow-none w-100"
                            onClick={() => {
                              handleResetFilter();
                            }}>
                            <i className="mdi mdi-restore align-bottom fs-18"></i>
                          </button>
                        </div>
                      </Col>
                    </Row>
                  </CardBody>
                </Row>
              </CardBody>
            </Card>
          </Col>
        </Row>
        <Row className={view === "summaryjob" ? "mb-0" : "d-none"}>
          <Col lg={12}>
            <Card>
              <CardBody className="pt-0 mt-3">
                <div className="">
                  <table className="table mb-5 table-border fs-12">
                    <thead className="align-middle">
                      <tr className="table-active text-left fs-12 fw-semibold">
                        <td valign="top" className="text-start" style={{ width: "2%" }}>No</td>
                        <td valign="top" className="text-start">Uraian Pekerjaan</td>
                        <td valign="top" className="text-start">Vendor</td>
                        <td valign="top" className="text-start">Harga</td>
                        <td valign="top" className="">Unit</td>
                        <td valign="top" className="">Total</td>
                      </tr>
                    </thead>
                    <tbody>
                      {civilContractSummaryJobList.filter(f => f.name.toLowerCase().indexOf(searchValue.toLowerCase()) !== -1).map((d, i) => {
                        return <tr key={i}>
                          <td valign="top" className="">{i + 1}</td>
                          <td valign="top" className="">{d.name}</td>
                          <td valign="top" className="">
                            {(d.vendor || []).map((item, key) => {
                              return <span key={key} className="m-0 text-left badge me-1 mb-1 text-uppercase badge-soft-info"> {item} </span>
                            })}
                          </td>
                          <td valign="top" className="">{currencyFormat(d.amount)}</td>
                          <td valign="top" className="fw-semibold">{d.unit}</td>
                          <td valign="top" className="fw-semibold">{currencyFormat(d.amount * d.unit)}</td>
                        </tr>
                      })}
                    </tbody>
                  </table>
                </div>
              </CardBody>
            </Card>
          </Col>
        </Row>
        <Row className={view === "summaryjobsupplier" ? "mb-0" : "d-none"}>
          <Col lg={12}>
            <Card>
              <CardBody className="pt-0 mt-3">
                <div className="">
                  <table className="table mb-5 table-border fs-12">
                    <thead className="align-middle">
                      <tr className="table-active text-left fs-12 fw-semibold">
                        <td valign="top" className="text-start" style={{ width: "2%" }}>No</td>
                        <td valign="top" className="text-start">Uraian Pekerjaan</td>
                        <td valign="top" className="text-start">Vendor</td>
                        <td valign="top" className="text-start">Harga</td>
                        <td valign="top" className="">Unit</td>
                        <td valign="top" className="">Total</td>
                      </tr>
                    </thead>
                    <tbody>
                      {civilContractSummaryJobSupplierList
                        .filter(f => f.name.toLowerCase().indexOf(searchValue.toLowerCase()) !== -1 || f.vendor.toLowerCase().indexOf(searchValue.toLowerCase()) !== -1)
                        .sort((a, b) => (a.name ?? "").localeCompare((b.name ?? ""), undefined, { numeric: true, sensitivity: 'base' }))
                        .map((d, i) => {
                          return <tr key={i}>
                            <td valign="top" className="">{i + 1}</td>
                            <td valign="top" className="">{d.name}</td>
                            <td valign="top" className="">{d.vendor}</td>
                            <td valign="top" className="">{currencyFormat(d.amount)}</td>
                            <td valign="top" className="fw-semibold">{d.unit}</td>
                            <td valign="top" className="fw-semibold">{currencyFormat(d.amount * d.unit)}</td>
                          </tr>
                        })}
                    </tbody>
                  </table>
                </div>
              </CardBody>
            </Card>
          </Col>
        </Row>
        <Row className={view === "summary" ? "mb-0" : "d-none"}>
          <Col lg={12}>
            <Card>
              <CardBody className="pt-0 mt-3">
                {civilContractSummaryList.filter(f => f.vendor.toLowerCase().indexOf(searchValue.toLowerCase()) !== -1).map((d, i) => {
                  return <div className="" key={i}>
                    <h3 className="card-title mb-3 text-info text-left fw-semibold">{d.vendor}</h3>
                    <table className="table mb-5 table-border fs-12">
                      <thead className="align-middle">
                        <tr className="table-active text-left fs-12 fw-semibold">
                          <td valign="top" className="text-start" style={{ width: "2%" }}>No</td>
                          <td valign="top" className="text-start" style={{ width: "8%" }}>Tanggal Surat Tugas</td>
                          <td valign="top" className="" style={{ width: "8%" }}>No Surat Tugas</td>
                          <td valign="top" className="" style={{ width: "28%" }}>Item Pekerjaan</td>
                          <td valign="top" className="text-end" style={{ width: "10%" }}>Sub Total</td>
                          <td valign="top" className="text-center" style={{ width: "4%" }}>Unit</td>
                          <td valign="top" className="text-end" style={{ width: "10%" }}>Total</td>
                          <td valign="top" className="text-end" style={{ width: "10%" }}>Tagihan</td>
                          <td valign="top" className="text-end" style={{ width: "10%" }}>Terbayar</td>
                          <td valign="top" className="text-end" style={{ width: "10%" }}>Sisa</td>
                        </tr>
                      </thead>
                      <tbody>
                        <tr className="fs-14 fw-semibold">
                          <td valign="top" colSpan={6}>TOTAL TAGIHAN {d.vendor} : <span className="text-danger ms-1">{currencyFormat((d.data || []).reduce((a, v) => (a = a + (parseFloat(v.payable_amount || 0) - parseFloat(v.paid_amount || 0))), 0))}</span></td>
                          <td valign="top" className="text-end fw-semibold" style={{ width: "10%" }}>{currencyFormat((d.data || []).reduce((a, v) => (a = a + parseFloat(v.amount || 0)), 0))}</td>
                          <td valign="top" className="text-end fw-semibold text-info" style={{ width: "10%" }}>{currencyFormat((d.data || []).reduce((a, v) => (a = a + parseFloat(v.payable_amount || 0)), 0))}</td>
                          <td valign="top" className="text-end fw-semibold text-success" style={{ width: "10%" }}>{currencyFormat((d.data || []).reduce((a, v) => (a = a + parseFloat(v.paid_amount || 0)), 0))}</td>
                          <td valign="top" className="text-end fw-semibold text-danger" style={{ width: "10%" }}>{currencyFormat((d.data || []).reduce((a, v) => (a = a + (parseFloat(v.amount || 0) - parseFloat(v.paid_amount || 0))), 0))}</td>
                        </tr>
                        {(d.data || []).map((data, idx) => {
                          return <tr key={idx}>
                            <td valign="top" className="">{idx + 1}</td>
                            <td valign="top" className="">{handleValidDate(data.transactionat)}</td>
                            <td valign="top" className="">{data.transaction_no}</td>
                            <td valign="top" className="">
                              <ul style={{ marginLeft: "-21px" }} className="mb-0">
                                {(data.budget || []).map((item, key) => {
                                  return <li key={key} className="m-0 text-left">
                                    {item.label},  Rp. {currencyFormat(item.amount)}
                                  </li>
                                }
                                )}
                              </ul>
                            </td>
                            <td valign="top" className="text-end">{currencyFormat((data.budget || []).reduce((a, v) => (a = a + parseFloat(v.amount || 0)), 0))}</td>
                            <td valign="top" className="text-center">{data.unit.length}</td>
                            <td valign="top" className="text-end fw-semibold">{currencyFormat(data.amount)}</td>
                            <td valign="top" className="text-end fw-semibold text-info">{currencyFormat(data.payable_amount || 0)}</td>
                            <td valign="top" className="text-end fw-semibold text-success">{currencyFormat(data.paid_amount || 0)}</td>
                            <td valign="top" className="text-end fw-semibold text-danger">{currencyFormat(data.amount - data.paid_amount || 0)}</td>
                          </tr>
                        })}
                      </tbody>
                    </table>
                  </div>
                })}
              </CardBody>
            </Card>
          </Col>
        </Row>
        <Row className={view === "opname" ? "mb-0" : "d-none"}>
          <Col lg={8}>
            <Card>
              <CardBody className="pt-0 mt-3">
                <div className="table-responsive table-card mb-1">
                  <Table hover {...getTableProps()} className="align-middle">
                    <thead className="bg-soft-info">
                      {headerGroups.map((headerGroup, index) => (
                        <tr {...headerGroup.getHeaderGroupProps()} className={""} key={index}>
                          {headerGroup.headers.map((column, index) => (
                            <th key={index} className={"" + generateFilterable(column)} {...column.getSortByToggleProps()} style={{ width: column.width + "%" }}>
                              {column.render("Header")}
                              {generateSortingIndicator(column)}
                              {/* <Filter column={column} /> */}
                            </th>
                          ))}
                        </tr>
                      ))}
                    </thead>
                    <tbody {...getTableBodyProps()}>
                      {page.map((row) => {
                        prepareRow(row);
                        return (
                          <Fragment key={row.getRowProps().key}>
                            <tr>
                              {row.cells.map((cell, index) => {
                                return (
                                  <td valign="top" {...cell.getCellProps()} key={index}>
                                    {cell.render("Cell")}
                                  </td>
                                );
                              })}
                            </tr>
                          </Fragment>
                        );
                      })}
                    </tbody>
                  </Table>
                </div>
                <Row className="justify-content-md-end justify-content-center align-items-center p-2">
                  <Col className="col-md-auto d-none d-md-block">
                    {rows.length} Data
                  </Col>
                  <Col className="col-md-auto">
                    <div className="d-flex gap-1">
                      <Button className="btn btn-light" onClick={previousPage} disabled={!canPreviousPage}>
                        {"<"}
                      </Button>
                    </div>
                  </Col>
                  <Col className="col-md-auto d-none d-md-block">
                    Halaman {pageIndex + 1} dari {pageOptions.length}
                  </Col>
                  <Col className="col-md-auto">
                    <Input type="number" min={1} style={{ width: 70 }} max={pageOptions.length} defaultValue={pageIndex + 1} onChange={onChangeInInput} />
                  </Col>
                  <Col className="col-md-auto">
                    <div className="d-flex gap-1">
                      <Button className="btn btn-light" onClick={nextPage} disabled={!canNextPage}>
                        {">"}
                      </Button>
                    </div>
                  </Col>
                </Row>
              </CardBody>
            </Card>
          </Col>
          <Col lg={4} style={{ position: "relative" }}>
            <Card style={{ position: "sticky", top: "90px" }}>
              <CardHeader className="align-items-center">
                <h3 className="card-title mb-0 flex-grow-1 fw-semibold">
                  PROGRESS PEKERJAAN
                  <div className="hstack gap-2 pt-2">
                    <div className="text-success mt-2 w-50">{info?.cvl_contract_vendor?.name}</div>
                    <div className="mt-2 w-50 text-end">Rp. {currencyFormat((info.amount))}</div>
                  </div>
                </h3>
              </CardHeader>
              {info && (
                <CardBody className="pb-3">
                  <div className="mb-3 pb-3">
                    <p className="card-title mb-0 flex-grow-1"></p>
                    <p className="card-title mb-0 flex-grow-1">{info?.cvl_contract_account?.name}</p>
                    <div className="hstack gap-2 fs-18">
                      <div className="fs-13 w-50">TOTAL PROGRES</div>
                      <div className="w-50">
                        <Progress value={progressTotal} color={progressTotal < 50 ? "danger" : progressTotal < 80 ? "warning" : "success"} className="animated-progess custom-progress progress-label mt-3 w-100">
                          <div className={progressTotal < 50 ? "label text-danger bg-soft-danger fs-12" : progressTotal < 80 ? "label text-warning bg-soft-warning fs-12" : "label text-success bg-soft-success fs-12"}>{progressTotal} %</div>
                        </Progress>
                      </div>
                    </div>
                    <div className="hstack gap-2 fs-15 pt-3">
                      <div className="fs-13 w-50">TAGIHAN OPNAME</div>
                      <div className="w-50 fw-semibold">Rp. {info.unit ? currencyFormat(progressPrice) : 0}</div>
                    </div>
                    <div className="hstack gap-2 fs-15 pt-3">
                      <div className="fs-13 w-50">TERBAYAR</div>
                      <div className="w-50 fw-semibold">Rp. {info.paid_amount ? currencyFormat(info.paid_amount) : 0}</div>
                    </div>
                    <div className="mt-3 mb-0">
                      {info.statusId === 2 && (info.amount - info.payable_amount) > 0 && (
                        <button
                          className={userType === "admin" || userType === "client" ? ("btn me-2 btn-sm btn-info") : userRole && userRole.split(",").indexOf("approveCivilContract") !== -1 ? "btn me-2 btn-sm btn-soft-info" : "d-none"}
                          onClick={() => {
                            toggleAccPayable();
                          }}>
                          <i className="ri-file-list-3-line fs-12 label-icon align-middle me-1"></i> INVOICE
                        </button>
                      )}
                      {/* {info.statusId === 2 && userType === "admin" && (
                        <button
                          className={userType === "admin" || userType === "client" ? ("btn me-2 btn-sm btn-success") : userRole && userRole.split(",").indexOf("processPurchase") !== -1 ? "btn me-2 btn-sm btn-success" : "d-none"}
                          onClick={() => {
                            validationAccPayment.setFieldValue("amount", parseFloat(info.amount) - parseFloat(info.paid_amount || 0));
                            toggleAccPayment();
                          }}>
                          <i className="ri-checkbox-circle-line fs-16 label-icon align-middle me-1"></i> PEMBAYARAN
                        </button>
                      )} */}
                    </div>
                  </div>
                  {info.unit && <div className="table-card p-3">
                    <table className="table mb-0 border table-striped fs-12">
                      <thead className="align-middle">
                        <tr className="table-active text-center fs-12 fw-semibold">
                          <td valign="top" className="w-25 text-start">UNIT</td>
                          <td valign="top" className="w-25">BOBOT</td>
                          <td valign="top" className="w-50">PROGRES</td>
                        </tr>
                      </thead>
                    </table>

                    <SimpleBar style={{ maxHeight: "320px" }}>
                      <table className="table border table-striped fs-12 mb-3 w-100">
                        <tbody>
                          {(progressUnitList || []).map((obj, key) => {
                            let weight = obj.weight || 0;
                            let completed = obj.completed;
                            let joblist = obj.joblist;
                            let percentage = obj.amount ? parseFloat((obj.amount / obj.amount_total) * 100).toFixed(2) : 0;
                            return (
                              <tr key={key} className="text-center">
                                <td valign="top" className="fw-semibold w-25 text-start">
                                  <Button
                                    color="light"
                                    className="btn-sm"
                                    onClick={() => {
                                      setUnit(obj);
                                      toggleProgress();
                                    }}>
                                    <i className="ri-eye-line fs-15"></i>
                                  </Button>
                                  {obj.name}
                                </td>
                                <td valign="top" className="fs-12 w-25">{percentage} %</td>
                                <td valign="top" className="ps-4 w-50">
                                  <Progress value={percentage} color={percentage < 50 ? "danger" : percentage < 80 ? "warning" : "success"} className="animated-progess custom-progress progress-label mt-3 w-100">
                                    <div className={percentage < 50 ? "label text-danger bg-soft-danger fs-10" : percentage < 80 ? "label text-warning bg-soft-warning fs-10" : "label text-success bg-soft-success fs-10"}>{percentage} %</div>
                                  </Progress>
                                </td>
                              </tr>
                            );
                          })}
                        </tbody>
                      </table>
                    </SimpleBar>
                  </div>}
                  <div>&nbsp;</div>
                </CardBody>
              )}
            </Card>
          </Col>
        </Row>
        <Modal id="showModalCivilContractProduction" isOpen={modal} centered size="xl">
          <ModalHeader className="bg-light p-3" toggle={toggle}>
            {isEdit ? "EDIT" : "COPY"} SURAT TUGAS &nbsp;
            {loading && (
              <>
                <Spinner color="primary" type="grow" size={"sm"}>
                  Loading...
                </Spinner>
                &nbsp;
                <Spinner color="success" type="grow" size={"sm"}>
                  Loading...
                </Spinner>
                &nbsp;
              </>
            )}
          </ModalHeader>
          <Form
            onSubmit={(e) => {
              e.preventDefault();
              validation.handleSubmit();
              return false;
            }}>
            <ModalBody>
              <CardBody>
                <Row>
                  <div className="mb-3 col-lg-4">
                    <div className="mb-3">
                      <div className="position-relative">
                        <Label className="form-label">
                          Grup Usaha
                        </Label>
                        <Select
                          name="client"
                          value={validation.values.client}
                          isDisabled={userType === "admin" || userType === "client" ? false : true}
                          placeholder="Pilih Grup Usaha"
                          onChange={(e) => {
                            setCompanyList([]);
                            setCivilBudgetList([]);
                            setVendorList([]);
                            setBranchList([]);
                            validation.setFieldValue("company", "");
                            validation.setFieldValue("vendor", "");
                            validation.setFieldValue("branch", "");
                            validation.setFieldValue("client", e);
                          }}
                          options={clientList}></Select>
                        <div
                          className="position-absolute"
                          style={{ top: "12px", left: "-24px" }}>
                          {clientLoading && (
                            <Spinner color="primary" size="sm">
                              Loading...
                            </Spinner>
                          )}
                        </div>
                      </div>
                      {validation.touched.client && validation.errors.client ? (
                        <p className="invalid-feedback d-block" type="invalid">
                          {validation.errors.client}
                        </p>
                      ) : null}
                    </div>
                    <div className="mb-3">
                      <Label className="form-label">
                        Perusahaan
                      </Label>
                      <div className="position-relative">
                        <Select
                          name="company"
                          value={validation.values.company}
                          placeholder="Pilih Perusahaan"
                          isDisabled={userType === "admin" || userType === "client" ? false : true}
                          onChange={(e) => {
                            dispatch(setCompanySelect(e));
                            setCivilBudgetList([]);
                            setVendorList([]);
                            setBranchList([]);
                            setProductList([]);
                            setAccountingList([]);
                            validation.resetForm();
                            validation.setFieldValue("company", e);
                          }}
                          options={companyList}></Select>
                        <div
                          className="position-absolute"
                          style={{
                            top: "12px",
                            left: "-24px",
                          }}>
                          {companyLoading && (
                            <Spinner color="primary" size="sm">
                              Loading...
                            </Spinner>
                          )}
                        </div>
                      </div>
                      {validation.touched.company && validation.errors.company ? (
                        <p className="invalid-feedback d-block" type="invalid">
                          {validation.errors.company}
                        </p>
                      ) : null}
                    </div>
                    <div className="mb-3">
                      <Label className="form-label">
                        Cabang
                      </Label>
                      <Select
                        name="branch"
                        placeholder="Pilih Cabang / Proyek"
                        value={validation.values.branch}
                        onChange={(e) => {
                          validation.setFieldValue("branch", e);
                          validation.setFieldValue("items", []);
                          handleGetCivilContract(validation.values.company.value, e.value);
                          setBranchIdSelected(e.value);
                        }}
                        options={branchList}></Select>
                      {validation.touched.branch && validation.errors.branch && (
                        <small className="text-danger" type="invalid">
                          {validation.errors.branch}
                        </small>
                      )}
                    </div>
                    <div className="mb-3">
                      <Label className="form-label">
                        Departemen
                      </Label>
                      <div className="position-relative">
                        <Select
                          name="department"
                          value={validation.values.department}
                          placeholder="Pilih Departemen"
                          onChange={(e) => {
                            validation.setFieldValue("department", e);
                          }}
                          options={departmentList}></Select>
                        <div className="position-absolute" style={{ top: "12px", left: "-24px" }}>
                          {departmentLoading && (
                            <Spinner color="primary" size="sm">
                              Loading...
                            </Spinner>
                          )}
                        </div>
                      </div>
                      {validation.touched.department && validation.errors.department && (
                        <p className="invalid-feedback d-block" type="invalid">
                          {validation.errors.department}
                        </p>
                      )}
                    </div>
                    <div className="mb-3">
                      <Label className="form-label">
                        Vendor
                      </Label>
                      <div className="position-relative">
                        <Select
                          name="vendor"
                          value={validation.values.vendor}
                          placeholder="Pilih Supplier"
                          onChange={(e) => {
                            validation.setFieldValue("vendor", e);
                          }}
                          options={vendorList}></Select>
                        <div
                          className="position-absolute"
                          style={{
                            top: "12px",
                            left: "-24px",
                          }}>
                          {vendorLoading && (
                            <Spinner color="primary" size="sm">
                              Loading...
                            </Spinner>
                          )}
                        </div>
                        {validation.touched.vendor && validation.errors.vendor && (
                          <p className="invalid-feedback d-block" type="invalid">
                            {validation.errors.vendor}
                          </p>
                        )}
                      </div>
                    </div>
                    <div className="mb-3 col-lg-12">
                      <label className="form-label" htmlFor="account">
                        Anggaran Teknik
                      </label>
                      <Select
                        name="cvl_budget"
                        value={validation.values.cvl_budget}
                        placeholder="Pilih Item Anggaran Teknik Terkait"
                        onChange={(e) => {
                          validation.setFieldValue("cvl_budget", e);
                        }}
                        options={civilBudgetDetailList}></Select>
                      {validation.touched.cvl_budget && validationAccPayment.errors.cvl_budget && (
                        <small className="text-danger" type="invalid">
                          {validation.errors.cvl_budget}
                        </small>
                      )}
                    </div>
                    <div className="mb-3">
                      <Label className="form-label">
                        Cashflow
                      </Label>
                      <Select
                        name="cashflow"
                        value={validation.values.cashflow}
                        placeholder="Pilih Cashflow"
                        onChange={(e) => {
                          validation.setFieldValue("cashflow", e);
                        }}
                        options={budgetList}></Select>
                      {validation.touched.cashflow && validation.errors.cashflow && (
                        <small className="text-danger" type="invalid">
                          {validation.errors.cashflow}
                        </small>
                      )}
                    </div>
                    <div className={userType === "admin" ? "mb-3" : "d-none"}>
                      <Label className="form-label">
                        Tagihan Opname
                      </Label>
                      <CurrencyInput
                        id="payable_amount"
                        name="payable_amount"
                        prefix="Rp. "
                        style={{ border: "1px solid #ccc" }}
                        className="form-control product-price"
                        placeholder="Terbayar"
                        defaultValue={validation.values.payable_amount}
                        decimalsLimit={2}
                        onFocus={(e) => e.target.select()}
                        onValueChange={(value, name, values) => {
                          validation.setFieldValue("payable_amount", parseFloat(value));
                        }}
                      />
                    </div>
                    <div className={userType === "admin" ? "mb-3" : "d-none"}>
                      <Label className="form-label">
                        Terbayar
                      </Label>
                      <CurrencyInput
                        id="paid_amount"
                        name="paid_amount"
                        prefix="Rp. "
                        style={{ border: "1px solid #ccc" }}
                        className="form-control product-price"
                        placeholder="Terbayar"
                        defaultValue={validation.values.paid_amount}
                        decimalsLimit={2}
                        onFocus={(e) => e.target.select()}
                        onValueChange={(value, name, values) => {
                          validation.setFieldValue("paid_amount", parseFloat(value));
                        }}
                      />
                    </div>
                  </div>
                  <div className="mb-3 col-lg-8">
                    <div className="mb-3">
                      <Label className="form-label">
                        Uraian Pekerjaan
                      </Label>
                      <Select
                        name="budget"
                        value={validation.values.budget}
                        isMulti
                        placeholder="Pilih item Anggaran"
                        onChange={(e) => {
                          validation.setFieldValue("budget", e);
                          let amount = 0;
                          for (const data of e) {
                            amount += parseFloat(data.amount || 0) * validation.values.unit.length
                          }
                          validation.setFieldValue("amount", amount);
                        }}
                        options={civilBudgetList}></Select>
                    </div>
                    <div className="mb-3">
                      <Label className="form-label">
                        Blok
                      </Label>
                      <Select
                        name="block"
                        placeholder="Blok"
                        value={validation.values.block}
                        isMulti
                        onChange={(opt, { option }) => {
                          let newOpts = opt;
                          if (option && option.value === "all") {
                            let filteredOptions = clone(blockList);
                            filteredOptions = filteredOptions[0].options.filter((filteredOption) => !newOpts.includes(filteredOption));
                            newOpts = newOpts.concat(filteredOptions).filter((newOpt) => newOpt.value !== "all");
                          }
                          validation.setFieldValue("block", newOpts);
                          let arrUnit = [];
                          newOpts.forEach((block) => {
                            (productVarians || []).forEach((item) => {
                              const varian = item.pvar_product ? item.pvar_product : "";
                              const category = varian.product_category ? varian.product_category.name : "";
                              const blck = varian.product_block ? varian.product_block.id : "";
                              const branch = varian.branchId ? varian.branchId : "";
                              const blck_name = varian.product_block ? varian.product_block.name : "";
                              const name = blck_name + "-" + varian.name;
                              const id = item.id;
                              const barcode = item.barcode;
                              const sku = item.sku;
                              const brandId = item.brandId;
                              const productId = item.productId;
                              if (block.value === blck) {
                                if (varian.branchId === branchIdSelected) {
                                  arrUnit.push({ label: name, name: name, barcode: barcode, sku: sku, value: productId, brandId: brandId, productId: productId, productVarianId: id });
                                }
                              }
                            });
                          });
                          validation.setFieldValue("unit", arrUnit.reduce((unique, o) => {
                            if (!unique.some(obj => obj.label === o.label && obj.value === o.value)) {
                              unique.push(o);
                            }
                            return unique;
                          }, []).sort((a, b) => (a.label ?? "").localeCompare((b.label ?? ""), undefined, { numeric: true, sensitivity: 'base' })));

                          let amount = 0;
                          for (const data of validation.values.budget) {
                            amount += parseFloat(data.amount || 0) * arrUnit.length
                          }
                          validation.setFieldValue("amount", amount);
                        }}
                        options={blockList}></Select>
                      {validation.touched.block && validation.errors.block && (
                        <small className="text-danger" type="invalid">
                          {validation.errors.block}
                        </small>
                      )}
                    </div>
                    <div className="mb-3">

                      <Label className="form-label">
                        Unit
                      </Label>
                      <Select
                        name="unit"
                        value={validation.values.unit}
                        placeholder="Blok Rumah Terkait"
                        isMulti
                        onChange={(opt, { option }) => {
                          var block = validation.values.block || [];
                          let newOpts = opt;
                          if (option && option.value === "all") {
                            let filteredOptions = clone(productList);
                            filteredOptions = filteredOptions[0].options.filter((filteredOption) => !newOpts.includes(filteredOption));
                            newOpts = newOpts.concat(filteredOptions).filter((newOpt) => newOpt.value !== "all");
                          }
                          validation.setFieldValue("unit", newOpts);

                          for (const item of newOpts) {
                            const findVarian = productVarians.find((d) => d.id === item.productVarianId);
                            if (findVarian?.pvar_product?.product_block?.id) {
                              let dataBlock = block.find((d) => d.value === findVarian?.pvar_product?.product_block?.id);
                              if (!dataBlock) block.push({ label: findVarian?.pvar_product?.product_block?.name, value: findVarian?.pvar_product?.product_block?.id })
                            }
                          }
                          validation.setFieldValue("block", block);

                          let amount = 0;
                          for (const data of validation.values.budget) {
                            amount += parseFloat(data.amount || 0) * newOpts.length
                          }
                          validation.setFieldValue("amount", amount);
                        }}
                        options={productList}
                        noOptionsMessage={(e) => "Type User to get option"}></Select>
                    </div>

                    <div className="row">
                      <div className="mb-3 col-lg-4">
                        <Label className="form-label">
                          Tanggal Mulai
                        </Label>
                        <Flatpickr
                          name="startat"
                          className="form-control"
                          placeholder="Tanggal Mulai"
                          options={{ enableTime: false, dateFormat: "Y/m/d" }}
                          value={validation.values.startat ?? ""}
                          onChange={(o, e) => {
                            validation.setFieldValue("startat", e);
                          }} />
                        {validation.touched.startat && validation.errors.startat && (
                          <p className="text-danger" type="invalid">
                            {validation.errors.startat}
                          </p>
                        )}
                      </div>
                      <div className="mb-3 col-lg-4">

                        <Label className="form-label">
                          Tanggal Berakhir
                        </Label>
                        <Flatpickr
                          name="endat"
                          className="form-control"
                          placeholder="Tanggal Berakhir"
                          options={{ enableTime: false, dateFormat: "Y/m/d" }}
                          value={validation.values.endat ?? ""}
                          onChange={(o, e) => {
                            validation.setFieldValue("endat", e);
                          }} />
                        {validation.touched.endat && validation.errors.endat && (
                          <p className="text-danger" type="invalid">
                            {validation.errors.endat}
                          </p>
                        )}
                      </div>
                      <div className="mb-3 col-lg-4">

                        <Label className="form-label">
                          Nilai Kontrak
                        </Label>
                        <CurrencyInput id="amount" name="amount" prefix="Rp. " style={{ border: "1px solid #ccc", width: "100%" }} className="form-control fw-semibold" placeholder="Input Nilai Kontrak" value={validation.values.amount} decimalsLimit={2} onFocus={(e) => e.target.select()} onValueChange={(value, name, values) => validation.setFieldValue("amount", value)} />
                        {validation.touched.amount && validation.errors.amount && (
                          <p className="invalid-feedback d-block" type="invalid">
                            {validation.errors.amount}
                          </p>
                        )}
                      </div>
                    </div>

                    <div className="mb-3 d-flex justify-content-between">
                      <Label htmlFor="education" className="form-label">
                        Dokumen
                      </Label>
                      <button
                        type="button"
                        className="btn btn-sm btn-label btn-soft-success"
                        onClick={() => {
                          toggleMedia();
                        }}>
                        <i className="ri-file-cloud-fill label-icon align-middle fs-16 me-1"></i> Media
                      </button>
                    </div>
                    {invDocImg.map((f, i) => {
                      if (f.isDeleted) {
                        return null;
                      } else {
                        return (
                          <div key={i} className="border-bottom mb-3">
                            <div className="d-flex justify-content-between mb-3 align-items-center">
                              <div className="me-2">
                                <img src={f.filename === "" ? logo : `${api.MEDIA_URL}/media/${f.filename}`} alt="" data-dz-thumbnail="" height="30" className="avatar-xs rounded bg-light" />
                              </div>
                              <div className="text-truncate">{f.filename}</div>
                              <div>
                                <Link
                                  to="#"
                                  className={"btn-icon btn btn-sm btn-soft-danger remove-item-btn mx-2"}
                                  onClick={(e) => {
                                    handleDeleteFile(f);
                                  }}>
                                  <i className="ri-delete-bin-line fs-15 text-danger"></i>
                                </Link>
                              </div>
                            </div>
                          </div>
                        );
                      }
                    })}
                    <div className="mb-3">
                      <Label htmlFor="address-field" className="form-label">
                        Keterangan
                      </Label>
                      <Input type="textarea" className="form-control" id="description" placeholder="Isi Keterangan " name="description" rows={3} value={validation.values.description ?? ""} onBlur={validation.handleBlur} onChange={validation.handleChange} invalid={validation.touched.description && validation.errors.description ? true : false} />
                      {validation.touched.description && validation.errors.description && (
                        <small className="text-danger" type="invalid">
                          {validation.errors.description}
                        </small>
                      )}
                    </div>
                  </div>
                </Row>
              </CardBody>
            </ModalBody>
            <div className="modal-footer">
              <div className="hstack gap-2 justify-content-end">
                <button
                  type="button"
                  className="btn btn-light"
                  onClick={() => {
                    toggle();
                  }}>
                  CLOSE
                </button>
                <button type="submit" className="btn btn-success" disabled={loading}>
                  <span className="d-flex align-items-center">
                    {!!isEdit ? "UPDATE ST" : "SIMPAN SURAT TUGAS"}
                    {loading && (
                      <Spinner size="sm" className="flex-shrink-0" role="status">
                        Loading...
                      </Spinner>
                    )}
                  </span>
                </button>
              </div>
            </div>
          </Form>
        </Modal>
        <Modal id="showModalAccPayment" isOpen={modalAccPayment} centered size="md">
          <ModalHeader className="bg-light p-3" toggle={toggleAccPayment}>
            PEMBAYARAN {info?.cvl_contract_vendor?.name}
          </ModalHeader>
          <Form
            onSubmit={(e) => {
              e.preventDefault();
              validationAccPayment.handleSubmit();
              return false;
            }}>
            <ModalBody>
              <div className="row">
                <div className="mb-3 col-lg-6">
                  <Label htmlFor="amount-field" className="form-label">
                    Jumlah
                  </Label>
                  <Input
                    name="amount"
                    id="amount-field"
                    className="form-control"
                    placeholder="Enter amount"
                    type="number"
                    onFocus={(e) => e.target.select()}
                    onChange={(e) => {
                      let paid_amount = !isNaN(parseFloat(info.paid_amount)) ? parseFloat(info.paid_amount) : 0;
                      let amount = !isNaN(parseFloat(info.amount)) ? parseFloat(info.amount) : 0;
                      let left_amount = amount - paid_amount;
                      if (!isNaN(parseFloat(e.target.value))) {
                        // if (parseFloat(e.target.value) <= left_amount) validationAccPayment.setFieldValue("amount", parseFloat(e.target.value));
                        // else validationAccPayment.setFieldValue("amount", left_amount);
                        validationAccPayment.setFieldValue("amount", parseFloat(e.target.value));
                      } else {
                        validationAccPayment.setFieldValue("amount", parseFloat(e.target.value));
                      }
                    }}
                    onBlur={validationAccPayment.handleBlur}
                    value={validationAccPayment.values.amount}
                    invalid={validationAccPayment.touched.amount && validationAccPayment.errors.amount ? true : false} />
                  {validationAccPayment.touched.amount && validationAccPayment.errors.amount ? <FormFeedback type="invalid">{validationAccPayment.errors.amount}</FormFeedback> : null}
                </div>
                <div className="mb-3 col-lg-6">
                  <Label htmlFor="amount-field" className="form-label">
                    Tanggal Pembayaran
                  </Label>
                  <Flatpickr
                    className="form-control"
                    id="datepicker-publish-input"
                    placeholder="Select transaction date"
                    options={{
                      mode: "single",
                      dateFormat: "Y/m/d",
                    }}
                    onChange={(selectedDates, dateStr) => {
                      validationAccPayment.setFieldValue("transactionat", dateStr);
                    }}
                    value={validationAccPayment.values.transactionat ?? ""} />
                </div>
                <div className="mb-3 col-lg-12">
                  <label className="form-label" htmlFor="account">
                    Akun Cash / Bank Pembayaran
                  </label>
                  <Select
                    name="account"
                    value={validationAccPayment.values.account}
                    placeholder="Enter account"
                    onChange={(e) => {
                      validationAccPayment.setFieldValue("account", e);
                    }}
                    options={accountingList}></Select>
                  {validationAccPayment.touched.account && validationAccPayment.errors.account && (
                    <small className="text-danger" type="invalid">
                      {validationAccPayment.errors.account}
                    </small>
                  )}
                </div>
              </div>
            </ModalBody>
            <div className="modal-footer">
              <div className="hstack gap-2 justify-content-end">
                <button
                  type="button"
                  className="btn btn-light"
                  onClick={() => {
                    setModalAccPayment(false);
                    validationAccPayment.resetForm();
                  }}>
                  Close
                </button>
                <button type="submit" className="btn btn-success">
                  <span className="d-flex align-items-center">
                    <span className="flex-grow-1 me-2">SIMPAN PEMBAYARAN</span>
                    {loading && (
                      <Spinner size="sm" className="flex-shrink-0" role="status">
                        Loading...
                      </Spinner>
                    )}
                  </span>
                </button>
              </div>
            </div>
          </Form>
        </Modal>
        <Modal id="showModalAccPayable" isOpen={modalAccPayable} centered size="lg">
          <ModalHeader className="bg-light p-3" toggle={toggleAccPayable}>
            TAGIHAN {info?.cvl_contract_vendor?.name}
          </ModalHeader>
          <Form
            onSubmit={(e) => {
              e.preventDefault();
              validationAccPayable.handleSubmit();
              return false;
            }}>
            <ModalBody>
              <div className="row">
                <div className="mb-3 col-lg-6">
                  <Label htmlFor="amount-field" className="form-label">
                    Jenis Transaksi
                  </Label>
                  <Select
                    name="paymentMethod"
                    value={validationAccPayable.values.paymentMethod}
                    placeholder="Pilih Jenis Transaksi"
                    onChange={(e) => {
                      validationAccPayable.setFieldValue("paymentMethod", e);
                    }}
                    options={paymentMethodList}
                  ></Select>
                  {validationAccPayable.touched.paymentMethod && validationAccPayable.errors.paymentMethod && (
                    <small className="text-danger" type="invalid">
                      {validationAccPayable.errors.paymentMethod}
                    </small>
                  )}
                </div>
                <div className="mb-3 col-lg-3">
                  <Label htmlFor="amount-field" className="form-label">
                    Jumlah
                  </Label>
                  <CurrencyInput
                    id="amount"
                    name="amount"
                    prefix="Rp. "
                    style={{ border: "1px solid #ccc" }}
                    className="form-control product-price"
                    placeholder="Terbayar"
                    defaultValue={progressPrice - info.payable_amount > 0 ? Math.round(progressPrice - info.payable_amount) : 0}
                    decimalsLimit={2}
                    onFocus={(e) => e.target.select()}
                    onValueChange={(value, name, values) => {
                      // let payable_amount = !isNaN(parseFloat(info.payable_amount)) ? parseFloat(info.payable_amount) : 0;
                      // let amount = !isNaN(parseFloat(info.amount)) ? parseFloat(info.amount) : 0;
                      // let left_amount = progressPrice ? progressPrice - payable_amount : amount - payable_amount;
                      validationAccPayable.setFieldValue("amount", parseFloat(value));
                    }}
                  />
                  {validationAccPayable.touched.amount && validationAccPayable.errors.amount && <p className="invalid-feedback d-block" type="invalid">{validationAccPayable.errors.amount}</p>}
                </div>
                <div className="mb-3 col-lg-3">
                  <Label htmlFor="amount-field" className="form-label">
                    Tanggal Tagihan
                  </Label>
                  <Flatpickr
                    className="form-control"
                    id="datepicker-publish-input"
                    placeholder="Select transaction date"
                    options={{
                      mode: "single",
                      dateFormat: "Y/m/d",
                    }}
                    onChange={(selectedDates, dateStr) => {
                      validationAccPayable.setFieldValue("transactionat", dateStr);
                    }}
                    value={validationAccPayable.values.transactionat ?? ""} />
                </div>
                <div className="mb-3">
                  <Input type="textarea" className="form-control" id="description" placeholder="Keterangan (Jika Ada)" name="description" rows={3} value={validationAccPayable.values.description ?? ""} onBlur={validationAccPayable.handleBlur} onChange={validationAccPayable.handleChange} invalid={validationAccPayable.touched.description && validationAccPayable.errors.description ? true : false} />
                </div>
              </div>
            </ModalBody>
            <div className="modal-footer">
              <div className="hstack gap-2 justify-content-end">
                <button
                  type="button"
                  className="btn btn-light"
                  onClick={() => {
                    setModalAccPayable(false);
                    validationAccPayable.resetForm();
                  }}>
                  Close
                </button>
                <button type="submit" className="btn btn-success">
                  <span className="d-flex align-items-center">
                    <span className="flex-grow-1 me-2">SIMPAN TAGIHAN</span>
                    {loading && (
                      <Spinner size="sm" className="flex-shrink-0" role="status">
                        Loading...
                      </Spinner>
                    )}
                  </span>
                </button>
              </div>
            </div>
          </Form>
        </Modal>
        <Modal id="showModalApprove" isOpen={modalApprove} centered size="md">
          <ModalHeader className="bg-light p-3" toggle={toggleApprove}>
            ACTION CONFIRMATION
          </ModalHeader>
          <Form
            onSubmit={(e) => {
              e.preventDefault();
              validationApprove.handleSubmit();
              return false;
            }}>
            <ModalBody>
              <div className="mt-2 text-center">
                <lord-icon src="https://cdn.lordicon.com/puvaffet.json" trigger="loop" colors="primary:#f7b84b,secondary:#f06548" style={{ width: "100px", height: "100px" }}></lord-icon>
                <div className="mt-4 pt-2 fs-15 mx-4 mx-sm-5">
                  <p className="fs-16">{civilContract && civilContract.actionTitle}</p>
                </div>
                <div className="mt-3 col-lg-12">
                  <Input name="approval_note" id="approval_note-field" className="form-control" placeholder="Enter Notes If Any" rows={4} type="textarea" onChange={validationApprove.handleChange} onBlur={validationApprove.handleBlur} />
                </div>
              </div>
            </ModalBody>
            <div className="modal-footer">
              <div className="hstack gap-2 justify-content-end">
                <button
                  type="button"
                  className="btn btn-light"
                  onClick={() => {
                    setModalApprove(false);
                  }}>
                  Tutup
                </button>
                <button type="submit" className="btn btn-success">
                  <span className="d-flex align-items-center">
                    <span className="flex-grow-1 me-2">Submit</span>
                    {loading && (
                      <Spinner size="sm" className="flex-shrink-0" role="status">
                        Loading...
                      </Spinner>
                    )}
                  </span>
                </button>
              </div>
            </div>
          </Form>
        </Modal>
        <Modal id="showModalDetail" isOpen={modalDetail} centered size="xl">
          <ModalHeader className="bg-light p-3" toggle={toggleDetail}>
            SURAT TUGAS
          </ModalHeader>
          {civilContract !== undefined && civilContract !== null ? (
            <ModalBody>
              <Row id="printThis">
                <Col lg={12}>
                  {printType === "spk" ?
                    <div className="hero-kwitansi">
                      {(companySelected?.value === 1 || companySelected?.value === 4) &&
                        <div style={{ display: "flex", padding: "5px 0", alignItems: "center", justifyContent: "center", fontSize: "11px", marginBottom: "15px" }}>
                          <div style={{ paddingRight: "30px", marginLeft: "-120px", width: "110px" }}>
                            <img src={logoHas} alt="" height="80" width="80" />
                          </div>
                          <div style={{ textAlign: "center", }}>
                            <p style={{ fontSize: "15px", margin: 0 }}>{companySelected?.label}</p>
                            <p style={{ fontSize: "15px", fontWeight: "normal", margin: 0 }}>Developer, Kontraktor & Trader</p>
                            <p style={{ fontSize: "15px", fontWeight: "normal", margin: 0 }}>Perum PESONA KAHURIPAN 1, Ruko Blok L No 1, Cikahuripan, Klapanunggal, Bogor</p>
                            <p style={{ fontSize: "15px", fontWeight: "normal", margin: 0 }}>Telp: 021-22886425 Email: pesonakahuripan@gmail.com</p>
                          </div>
                        </div>
                      }

                      {companySelected?.value === 2 &&
                        <div style={{ display: "flex", padding: "5px 0", alignItems: "center", justifyContent: "center", fontSize: "11px", marginBottom: "15px" }}>
                          <div style={{ paddingRight: "30px", marginLeft: "-120px", width: "110px" }}>
                            <img src={logoCms} alt="" height="80" width="80" />
                          </div>
                          <div style={{ textAlign: "left" }}>
                            <p style={{ fontSize: "15px", margin: 0 }}>{companySelected?.label}</p>
                            <p style={{ fontSize: "15px", fontWeight: "normal", margin: 0 }}>Developer, Kontraktor & Trader</p>
                            <p style={{ fontSize: "15px", fontWeight: "normal", margin: 0 }}>Perum PESONA KAHURIPAN 1, Ruko Blok L No 1, Cikahuripan, Klapanunggal, Bogor</p>
                            <p style={{ fontSize: "15px", fontWeight: "normal", margin: 0 }}>Telp: 021-22886425 Email: pesonakahuripan@gmail.com</p>
                          </div>
                        </div>
                      }

                      {companySelected?.value === 3 &&
                        <div style={{ display: "flex", padding: "5px 0", alignItems: "center", justifyContent: "center", fontSize: "11px", marginBottom: "15px" }}>
                          <div style={{ paddingRight: "30px", marginLeft: "-120px", width: "110px" }}>
                            <img src={logoWAP} alt="" height="80" width="80" />
                          </div>
                          <div style={{ textAlign: "left" }}>
                            <p style={{ fontSize: "15px", margin: 0 }}>{companySelected?.label}</p>
                            <p style={{ fontSize: "15px", fontWeight: "normal", margin: 0 }}>Developer, Kontraktor & Trader</p>
                            <p style={{ fontSize: "15px", fontWeight: "normal", margin: 0 }}>Jl Sudarmanik Desa Jagabaya Kec. Parung Panjang, Bogor</p>
                            <p style={{ fontSize: "15px", fontWeight: "normal", margin: 0 }}>Telp: 021-22886425 Email: pesonakahuripan@gmail.com</p>
                          </div>
                        </div>
                      }
                      <div
                        style={{
                          height: "1px",
                          width: "100%",
                          backgroundColor: "black",
                          marginBottom: "30px",

                        }}></div>


                      <div style={{ textAlign: "center", fontSize: "20px", marginBottom: "0px" }}>SURAT TUGAS</div>
                      <div style={{ textAlign: "center", marginBottom: "0px", fontWeight: "bold" }}>Nomor: {validValue(info?.transaction_no)}/{info?.cvl_contract_company?.code}-{info?.cvl_contract_branch?.branch_code}/ST/
                        {moment().format("M")}/{moment().format("YYYY")}</div>
                      <div style={{ textAlign: "center", marginBottom: "20px", fontSize: "16px" }}>{info?.cvl_contract_branch?.name}</div>
                      <div>
                        Pada hari ini {formatTanggalIndonesia(handleValidDate(info?.transactionat, "DD/MM/YYYY"))}.
                        Yang bertanda tangan dibawah ini :
                      </div>
                      <table style={{ marginBottom: "10px", marginTop: "10px", width: "100%" }}>
                        <tbody>
                          <tr>
                            <td valign="top" style={{ width: "160px", verticalAlign: "top" }}>Nama </td>
                            <td valign="top" style={{ width: "20px", verticalAlign: "top" }}>:</td>
                            <td valign="top" style={{ verticalAlign: "top" }}>{validValue(info?.cvl_contract_createdby?.name)}</td>
                          </tr>
                          <tr>
                            <td valign="top">Jabatan</td>
                            <td valign="top" style={{ width: "20px", verticalAlign: "top" }}>:</td>
                            <td valign="top" style={{ verticalAlign: "top" }}><p className="mb-0">{validValue("MANAGER PROYEK")}</p>
                            {/* <p className="mb-0">Dalam hal ini bertindak untuk dan atas nama {companySelected?.label} – {info?.cvl_contract_branch?.name}</p> */}
                            </td>
                          </tr>
                          {/* <tr>
                            <td valign="top">Alamat</td>
                            <td valign="top" style={{ width: "20px", verticalAlign: "top" }}>:</td>
                            <td valign="top" style={{ verticalAlign: "top" }}>{validValue("")}</td>
                          </tr> */}
                          <tr>
                            <td valign="top">No. Hp</td>
                            <td valign="top" style={{ width: "20px", verticalAlign: "top" }}>:</td>
                            <td valign="top" style={{ verticalAlign: "top" }}>{validValue("")}</td>
                          </tr>
                          {/* <tr>
                            <td valign="top">No. KTP</td>
                            <td valign="top" style={{ width: "20px", verticalAlign: "top" }}>:</td>
                            <td valign="top" style={{ verticalAlign: "top" }}>{validValue("")}</td>
                          </tr> */}
                        </tbody>
                      </table>
                      <div>
                        Selanjutnya disebut sebagai : {validValue("PEMBERI TUGAS")}
                      </div>
                      <table style={{ marginBottom: "10px", marginTop: "10px", width: "100%" }}>
                        <tbody>
                          <tr>
                            <td valign="top" style={{ width: "160px", verticalAlign: "top" }}>Nama </td>
                            <td valign="top" style={{ width: "20px", verticalAlign: "top" }}>:</td>
                            <td valign="top" style={{ verticalAlign: "top" }}>{validValue(info?.cvl_contract_vendor?.name)} &nbsp;</td>
                          </tr>
                          <tr>
                            <td valign="top" style={{ width: "160px", verticalAlign: "top" }}>Jabatan </td>
                            <td valign="top" style={{ width: "20px", verticalAlign: "top" }}>:</td>
                            <td valign="top" style={{ verticalAlign: "top" }}>{validValue("KOORDINATOR LAPANGAN")} 
                            {/* <p className="mb-0">Dalam hal ini bertindak untuk dan atas nama diri sendiri</p> */}
                            </td>
                          </tr>
                          {/* <tr>
                            <td valign="top">Alamat</td>
                            <td valign="top" style={{ width: "20px", verticalAlign: "top" }}>:</td>
                            <td valign="top" style={{ verticalAlign: "top" }}>{validValue("")}</td>
                          </tr> */}
                          <tr>
                            <td valign="top">No. Hp</td>
                            <td valign="top" style={{ width: "20px", verticalAlign: "top" }}>:</td>
                            <td valign="top" style={{ verticalAlign: "top" }}>{validValue("")}</td>
                          </tr>
                          {/* <tr>
                            <td valign="top">No. KTP</td>
                            <td valign="top" style={{ width: "20px", verticalAlign: "top" }}>:</td>
                            <td valign="top" style={{ verticalAlign: "top" }}>{validValue("")}</td>
                          </tr> */}
                        </tbody>
                      </table>
                       <div>
                        Selanjutnya disebut sebagai : {validValue("PENERIMA TUGAS")}
                      </div>

                      {/* <p style={{ fontSize: "14px", marginTop: "15px", marginBottom: "15px", verticalAlign: "top" }}>
                        Berdasarkan : <br />- Penawaran Harga Pembangunan Perumahan {info?.cvl_contract_branch?.name}
                      </p> */}
                      <div>Untuk segera melaksanakan pekerjaan Pembangunan Perumahan {info?.cvl_contract_branch?.name}  Type 30/60 M2 dengan ketentuan dan rincian sebagai berikut:</div>

                      <table style={{ marginBottom: "10px", marginTop: "10px", width: "100%" }}>
                        <tbody>
                          <tr>
                            <td valign="top" style={{ width: "160px", verticalAlign: "top" }}>1. Nama Proyek </td>
                            <td valign="top" style={{ width: "20px", verticalAlign: "top" }}>:</td>
                            <td valign="top" style={{ verticalAlign: "top" }}>{validValue(info?.cvl_contract_branch?.name)} &nbsp;</td>
                          </tr>
                          <tr>
                            <td valign="top" style={{ width: "160px", verticalAlign: "top" }}>2. Lokasi Proyek  </td>
                            <td valign="top" style={{ width: "20px", verticalAlign: "top" }}>:</td>
                            <td valign="top" style={{ verticalAlign: "top" }}>{validValue(info?.cvl_contract_branch?.description)}</td>
                          </tr>
                          <tr>
                            <td valign="top">3. Jenis Pekerjaan</td>
                            <td valign="top" style={{ width: "20px", verticalAlign: "top" }}>:</td>
                            <td valign="top" style={{ verticalAlign: "top" }}>
                              {validValue(info?.cvl_contract_cvl_account?.name)}</td>
                          </tr>
                          {/* <tr>
                            <td valign="top">4. Nilai Kontrak</td>
                            <td valign="top" style={{ width: "20px", verticalAlign: "top" }}>:</td>
                            <td valign="top" style={{ verticalAlign: "top" }}>{validValue("Rp" + currencyFormat(info.amount))} <p><em>{numberToWords(info.amount)}</em></p></td>
                          </tr> */}
                          <tr>
                            <td valign="top">4. Waktu Pelaksanaan</td>
                            <td valign="top" style={{ width: "20px", verticalAlign: "top" }}>:</td>
                            <td valign="top" style={{ verticalAlign: "top" }}>{validValue("Sejak Tanggal Surat Tugas ini turunkan")} {validValue(handleValidDate(info.startat) + " sampai dengan " + handleValidDate(info.endat))}</td>
                          </tr>
                          <tr>
                            <td valign="top">5. Masa Pemeliharaan</td>
                            <td valign="top" style={{ width: "20px", verticalAlign: "top" }}>:</td>
                            <td valign="top" style={{ verticalAlign: "top" }}>3 x 30 (Sembilan puluh) hari kalender</td>
                          </tr>
                          {/* <tr>
                            <td valign="top">7. Cara Pembayaran</td>
                            <td valign="top" style={{ width: "20px", verticalAlign: "top" }}>:</td>
                            <td valign="top" style={{ verticalAlign: "top" }}>45 Hari setelah tanggal invoice (Retensi 5%)</td>
                          </tr> */}
                        </tbody>
                      </table>

                      <table style={{ marginBottom: "10px", marginTop: "10px", width: "100%", border: "1px solid #333" }}>
                        <thead>
                          <tr className="bg-soft-info" >
                            <th className="text-center" style={{ padding: "3px", border: "1px solid #333" }}>No</th>
                            <th style={{ padding: "3px", border: "1px solid #333" }}>Pekerjaan</th>
                            <th className="text-center" style={{ padding: "3px", border: "1px solid #333" }}>Blok</th>
                            <th className="text-center" style={{ padding: "3px", border: "1px solid #333" }}>Satuan</th>
                            <th className="text-center" style={{ padding: "3px", border: "1px solid #333" }}>Volume</th>
                            <th className="text-end" style={{ padding: "3px", border: "1px solid #333" }}>Harga</th>
                            <th className="text-end" style={{ padding: "3px", border: "1px solid #333" }}>Total</th>
                          </tr>
                        </thead>
                        <tbody>
                          {jobList.length > 0 && (jobList || []).sort((a, b) => (a.label ?? "").localeCompare((b.label ?? ""), undefined, { numeric: true, sensitivity: 'base' })).map((o, i) => {
                            let completed = o.weight_finished && o.completed ? parseFloat(o.weight_finished / o.completed / info.unit.length).toFixed(2) : 0;
                            return (
                              <tr key={i} className="product">
                                <td className="text-center" style={{ height: "14px", padding: "3px", border: "1px solid #333" }}>{i + 1}</td>
                                <td valign="top" className="text-start" style={{ height: "14px", padding: "3px", border: "1px solid #333" }}>{o.label}</td>
                                <td valign="top" className="text-center" style={{ height: "14px", padding: "3px", border: "1px solid #333" }}>
                                  {(info.block || []).map((obj) => {
                                    return obj.label + " ";
                                  })}
                                </td>
                                <td valign="top" className="text-center" style={{ height: "14px", padding: "3px", border: "1px solid #333" }}>Unit</td>
                                <td valign="top" className="text-center" style={{ height: "14px", padding: "3px", border: "1px solid #333" }}>{info.unit.length}</td>
                                <td valign="top" className="text-end" style={{ height: "14px", padding: "3px", border: "1px solid #333" }}>{currencyFormat(parseFloat(o.amount))}</td>
                                <td valign="top" className="text-end" style={{ height: "14px", padding: "3px", border: "1px solid #333" }}>{currencyFormat(parseFloat(o.amount) * info.unit.length)}</td>
                              </tr>
                            );
                          })}
                        </tbody>
                      </table>
                      <p style={{ fontSize: "14px", marginTop: "15px", marginBottom: "15px" }}>
                        PENERIMA TUGAS sudah harus melaksanakan kegiatannya sejak Surat Tugas ini diterbitkan. Demikian Surat Tugas ini dibuat untuk segera dilaksanakan.
                      </p>
                      <Table
                        className="table table-borderless table-nowrap align-middle mb-0 ms-auto"
                        style={{ width: "100%" }}>
                        <tbody>
                          <tr>
                            <td valign="top" className="w-50">
                              <p className="mb-0 text-center">BOGOR, {validValue(handleValidDate(info.createdat))}</p>
                              <p className="mb-5 pb-3 fw-semibold text-center">PEMBERI KERJA</p>
                              <p style={{ height: "5px", marginBottom: "10px" }}></p>
                              <p className="mt-5 text-center">{validValue(info?.cvl_contract_createdby?.name)}</p>
                            </td>
                            <td valign="top" className="w-50">
                              <p className="mb-0 fw-semibold text-center">PENERIMA TUGAS</p>
                              <p style={{ height: "40px" }}></p>
                              <p className="mt-5 text-center">{validValue(info?.cvl_contract_vendor?.name)}</p>
                            </td>
                          </tr>
                        </tbody>
                      </Table>
                    </div>
                    :
                    <div>
                      <CardHeader className="border-bottom-dashed p-4">
                        <div className="d-flex">
                          <div className="flex-grow-1">
                            <img src={logoDark} className="card-logo card-logo-dark" alt="logo dark" height="50" />
                            <img src={logoLight} className="card-logo card-logo-light" alt="logo light" height="50" />
                            <div className="mt-sm-3 mt-3">
                              <h6 className="text-uppercase fw-semibold">{info?.cvl_contract_client?.name}</h6>
                              <p className="mb-1">{info?.cvl_contract_branch?.name}</p>
                              <p className="mb-1">Suplier: {info?.cvl_contract_vendor?.name}</p>
                            </div>
                          </div>
                        </div>
                      </CardHeader>
                      <CardBody className="p-4">
                        <Row className="g-3">
                          <Col lg={3} xs={3}>
                            <p className="text-muted mb-2 text-uppercase fw-semibold">No SPK</p>
                            <h5 className="fs-14 mb-0">
                              #<span id="invoice-no">{info.transaction_no || "PKG" + handleValidDate(info.transactionat, "YYYYMMDD") + info.id}</span>
                            </h5>
                          </Col>
                          <Col lg={5} xs={5}>
                            <p className="text-muted mb-2 text-uppercase fw-semibold">Blok</p>
                            <h5 className="fs-14 mb-0">
                              {(info.block || []).map((obj, key) => {
                                return (
                                  <span key={key} className="badge fs-14 text-uppercase badge-soft-light text-dark" >
                                    {obj.label}
                                  </span>
                                );
                              })}
                              <span className="badge fs-14 text-uppercase badge-soft-light text-dark">({info?.unit?.length} Unit)</span>
                            </h5>
                          </Col>
                          <Col lg={2} xs={2}>
                            <p className="text-muted mb-2 text-uppercase fw-semibold">Tanggal Mulai</p>
                            <h5 className="fs-14 mb-0">
                              <span id="invoice-date">{handleValidDate(info.transactionat)}</span>
                            </h5>
                          </Col>
                          <Col lg={2} xs={2}>
                            <p className="text-muted mb-2 text-uppercase fw-semibold">Tanggal Berakhir</p>
                            <h5 className="fs-14 mb-0">
                              <span id="invoice-date">{handleValidDate(info.dueat)}</span>
                            </h5>
                          </Col>
                        </Row>
                      </CardBody>
                      <CardBody className="p-4">
                        <div>
                          <Table className="table-borderless text-center table-nowrap align-middle mb-0">
                            <thead>
                              <tr className="table-active">
                                <th scope="col" style={{ width: "50px" }}>#</th>
                                <th scope="col" className="text-start">Detail Pekerjaan</th>
                                <th scope="col">Nilai Pekerjaan</th>
                                <th scope="col">% Bobot</th>
                                <th scope="col">Hasil Opname</th>
                                <th scope="col">% Opname</th>
                                <th scope="col">Nilai Opname</th>
                              </tr>
                            </thead>
                            <tbody id="products-list">
                              {jobList.length > 0 && (jobList || []).sort((a, b) => (a.label ?? "").localeCompare((b.label ?? ""), undefined, { numeric: true, sensitivity: 'base' })).map((o, i) => {
                                let completed = o.weight_finished && o.completed ? parseFloat(o.weight_finished / o.completed / info.unit.length).toFixed(2) : 0;
                                return (
                                  <tr key={i} className="product">
                                    <th scope="row" className="product-id" style={{ height: "14px" }}>{i + 1}</th>
                                    <td valign="top" className="text-start" style={{ height: "14px" }}>{o.label}</td>
                                    <td valign="top" style={{ height: "14px" }}>{currencyFormat(parseFloat(o.amount))}</td>
                                    <td valign="top" style={{ height: "14px" }}>{Math.round(o.weight ?? 0)} %</td>
                                    <td valign="top" style={{ height: "14px" }}>{parseFloat(o.completed ?? 0)} dari {info.unit.length}</td>
                                    <td valign="top" style={{ height: "14px" }}>{(completed * o.completed ?? 0).toFixed(2)} %</td>
                                    <td valign="top" className="fw-semibold" style={{ height: "14px" }}>{completed ? currencyFormat(parseFloat(o.completed * o.amount)) : 0} </td>
                                  </tr>
                                );
                              })}
                            </tbody>
                          </Table>
                        </div>
                        <div className="border-top border-bottom border-top-dashed mt-2 mb-3 pb-3">
                          <Table className="table table-borderless table-nowrap align-middle mb-0 ms-auto me-5" style={{ width: "250px" }}>
                            <tbody>
                              <tr>
                                <th>Total Bobot Tercapai</th>
                                <th className="text-end">{progressTotal} %</th>
                              </tr>
                              <tr>
                                <th>Harga Pekerjaan</th>
                                <th className="text-end">Rp{currencyFormat(info.amount)}</th>
                              </tr>
                              <tr>
                                <th className="text-danger">Retensi Pekerjaan (10%)</th>
                                <th className="text-end text-danger">Rp{currencyFormat(0.10 * info.amount)}</th>
                              </tr>
                              <tr>
                                <th>Hasil Opname Pekerjaan</th>
                                <th className="text-end">Rp{currencyFormat(progressPrice)}</th>
                              </tr>
                              <tr>
                                <th className="text-success">Terbayar</th>
                                <th className="text-end text-success">Rp{currencyFormat(info.paid_amount || 0)}</th>
                              </tr>
                              <tr className="border-top fs-15">
                                <th scope="row">SISA PEMBAYARAN</th>
                                <th className="text-end">Rp{currencyFormat(info.amount - (info.paid_amount || 0))}</th>
                              </tr>
                            </tbody>
                          </Table>
                        </div>
                        <div className="mt-4 row">
                          <div className="col-lg-6">
                            <p className="mb-0 text-center">Bogor, {handleValidDate(info.createdat)}</p>
                            <p className="mb-5 pb-3 fw-semibold text-center">{info?.cvl_contract_vendor?.name}</p>
                            <p style={{ height: "10px" }}></p>
                            <p className="mt-5 text-center">................................</p>
                          </div>
                          <div className="col-lg-6">
                            <p className="mb-0 text-center">{info.approvedat && handleValidDate(info.approvedat)}</p>
                            <p className="mb-0 text-center">Disetujui Oleh</p>
                            <p className="mb-5 pb-3 fw-semibold text-center">{info?.cvl_contract_approvedby?.name}</p>
                            <p style={{ height: "35px" }}></p>
                            <p className="mt-5 text-center">................................</p>
                          </div>
                        </div>
                      </CardBody>
                      <CardBody className="p-4">
                        <Row className="g-3">
                          {(info.purchase_file || []).map((f, i) => {
                            if (f.isDeleted) {
                              return null;
                            } else {
                              return (
                                <Col lg={2} xs={2} key={i}>
                                  {f.mimetype === "image/jpg" || f.mimetype === "image/png" || f.mimetype === "image/jpeg" ?
                                    <ModalImage showRotate={true}
                                      small={f.filename === "" ? "" : `${api.MEDIA_URL}/media/${f.filename}-w-50`}
                                      large={f.filename === "" ? "" : `${api.MEDIA_URL}/media/${f.filename}`}
                                      alt={f.originalname}
                                      className="img-thumbnail avatar-md img-thumbnail user-profile-image" />
                                    :
                                    <Link
                                      to={`${api.MEDIA_URL}/media/${f.filename}`}
                                      target="_blank"
                                      className={"img-thumbnail avatar-md img-thumbnail user-profile-image"}>
                                      <i className="ri-file-pdf-line fs-3 text-danger"></i>
                                    </Link>
                                  }</Col>);
                            }
                          })}
                        </Row>
                      </CardBody>
                    </div>
                  }

                </Col>
              </Row>
            </ModalBody>
          ) : null}
          <div className="modal-footer">
            <div className="hstack gap-2 justify-content-end">
              <button
                type="button"
                className="btn btn-light"
                onClick={() => {
                  setModalDetail(false);
                }}>
                Tutup
              </button>
              <button
                type="submit"
                className="btn btn-info"
                onClick={() => {
                  handlePrint();
                }}>
                Print Document&nbsp;{loadingPrint ? <Spinner size="sm" className="flex-shrink-0 ms-2" role="status"></Spinner> : ""}
              </button>
            </div>
          </div>
        </Modal>
        <Modal id="showModalProgress" isOpen={modalProgress} centered size="xl">
          <ModalHeader className="bg-light p-3" toggle={toggleProgress}>
            PROGRESS PEKERJAAAN {unit.label}
            {civilOpnameLoading && (
              <>
                <Spinner color="primary" type="grow" size={"sm"}>
                  Loading...
                </Spinner>
                &nbsp;
                <Spinner color="success" type="grow" size={"sm"}>
                  Loading...
                </Spinner>
                &nbsp;
              </>
            )}
          </ModalHeader>
          <ModalBody>
            <Row className="mb-4">
              <div className="col-lg-12">
                {(civilBudgetList.sort((a, b) => a.sort_order - b.sort_order) || []).map((obj, i) => {
                  return (
                    <div key={i} className="mb-3 border border-start-0 border-top-0 border-end-0 pb-2">
                      <p className="fw-semibold fs-14 text-uppercase m-1 text-primary">{obj.label}</p>
                      <div className={"pe-3 ps-3 row"}>
                        {(obj.options || []).map((o, idx) => {
                          let ischecked = false;
                          const findOpname = civilOpnames.find((f) => f?.cvlop_product?.id === unit.productId);
                          if (findOpname ? (findOpname.checked_progress.split(",").find((x) => x === o.civilAccountId.toString()) ? true : false) : false) {
                            ischecked = true;
                          }
                          return (
                            <div key={idx} className="hstack gap 2 mb-2 col-lg-4">
                              <div>
                                <Label className={ischecked ? "form-check-label fs-12 text-capitalize fw-semibold" : "form-check-label fw-normal fs-12 text-capitalize text-muted"}>
                                  <i className={ischecked ? "mt-2 fs-14 ri-check-line fw-semibold text-success me-1" : "mt-2 fs-14 ri-close-line me-1 text-danger"}></i> {o.label}
                                </Label>
                              </div>
                            </div>
                          );
                        })}
                      </div>
                    </div>
                  );
                })}
              </div>
            </Row>
          </ModalBody>
          <div className="modal-footer">
            <div className="hstack gap-2 justify-content-end">
              <button
                type="button"
                className="btn btn-light"
                onClick={() => {
                  setModalProgress(false);
                }}>
                Tutup
              </button>
            </div>
          </div>
        </Modal>
        <ModalInputFile onSelect={handleSelectFile} loading={loading} modal={modalMedia} toggle={toggleMedia} />
        <PrintDoc innerRef={printRef} item={info} jobList={jobList} progressTotal={progressTotal} progressPrice={progressPrice} type={printType} companyName={companySelected?.label} companyValue={companySelected?.value} />
      </Container>
    </div>
  );
};

export default CivilContract;
